import common from './common'
import featuresPay from './feature'

const fr = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "Produit/Variantes",
        serialNumber: "Numéro de Série",
        noProductsFound: "Aucun produit trouvé",
        searchByProductSku: "Rechercher par produit/SKU",
        searchSerialNumbers: "Rechercher des numéros de série",
        transactionDetails: "Détails de la Transaction",
        notAvailable: "N/D",
        mainWarehouse: "Entrepôt Principal"
    },
    new_build_banner: {
        title: 'Nouvelle version :',
        is_available: 'est maintenant disponible',
        fallback_title: 'Une nouvelle version de l\'application est disponible',
        desc: 'Actualisez pour obtenir les dernières fonctionnalités et améliorations.',
        refreshing: 'Actualisation…',
        refresh_now: 'Actualiser maintenant',
        later: 'Plus tard',
        you_are_on: "vous êtes sur"
    },
    short: {
        finance: 'Finance',
        stock: 'Stock'
    },
    onboarding: {
        welcome: 'Bienvenue !',
        step: {
            product: {
                totalBreakdown: 'Ventilation totale',
                overallFulfilment: 'Exécution globale',
                totalShippedQty: 'Qté totale expédiée',
                totalReceivedQty: 'Qté totale reçue',
                totalOrderedQty: 'Qté totale commandée',
                totalShippedOrdered: 'Total expédié / commandé',
                totalReceivedOrdered: 'Total reçu / commandé',
                viewQty: 'Voir la qté',
                fetchingQty: 'Récupération des détails de quantité...',
                noStockInfo: 'Aucune information de stock trouvée',
                title: '65 % Atteint',
                description: 'Il ne reste que 2 étapes pour commencer votre grand succès !',
                Warehouse: "Entrepôt",
            },
            stock: {
                title: '95 % Presque Fini !!',
                description: 'Il ne reste qu’une étape pour commencer votre grand succès ! Terminez-le maintenant.'
            }
        },
        business: {
            title: 'Entreprise créée avec succès !',
            description: 'Génial ! Votre entreprise a été enregistrée'
        },
        product: {
            title: 'Ajoutez votre premier produit',
            description: 'Ajoutez un produit pour commencer à enregistrer les stocks',
            Warehouse: "Entrepôt",
        },
        stock: {
            title: 'Essayez d’ajouter du stock',
            description: 'Commencez à enregistrer les entrées et sorties de stock'
        },
        action: {
            add_business: {
                title: 'Créer une Entreprise',
                description: 'Vous voulez créer une nouvelle entreprise ? Cliquez ici'
            },
            join_business: {
                title: 'Rejoindre une Entreprise',
                description: 'Vous avez un code d’invitation ? Rejoignez ici'
            }
        }
    },
    business: {
        title: 'Sélectionnez une entreprise, créez-en une nouvelle ou rejoignez-en une',
        add_business: {
            title: 'Créer une nouvelle entreprise',
            name: "Nom de l'entreprise",
            name_placeholder: 'Entrez le nom',
            category: "Catégorie d'entreprise",
            category_placeholder: 'Sélectionnez la catégorie',
            button: 'Créer une entreprise'
        },
        edit_business: {
            title: "Modifier l'entreprise"
        },
        join_business: {
            title: 'Rejoindre une entreprise',
            input_code: "Entrez le code d'invitation ci-dessous :",
            field_placeholder: "Code d'invitation",
            confirm_title: 'Rejoindre',
            confirm_text: "Vous ferez partie de l'équipe de "
        },
        no_business: 'Aucune entreprise disponible',
        create_or_join: 'Créer ou rejoindre une entreprise',
        message: {
            saved: 'Entreprise enregistrée avec succès !'
        },
        settings: {
            isNegativeTransactionDisabled: 'Transactions de stock négatif',
            isNegativeTransactionDisabledHint: 'En activant cette option, vous pouvez empêcher les transactions qui entraîneraient un stock négatif.',
            negativeStockError: 'Les transactions de stock négatif sont désactivées'
        }
    },
    profile: {
        edit_profile: {
            title: 'Modifier le profil',
            name: 'Nom complet',
            name_placeholder: 'Entrez le nom complet',
            email: 'Email',
            phone_number: 'Numéro de téléphone'
        },
        message: {
            required_name: 'Le nom est requis'
        }
    },
    product: {
        weightedAverageCost: 'Coût Moyen Pondéré',
        weightedAverageValueLabel: 'Valeur Moyenne Pondérée',
        Product: 'Produit',
        hideZeroStock: 'Masquer stock zéro',
        allVariants: 'Tous les variants',
        choose_product: 'Choisir le produit',
        choose_product_empty: 'Sélectionnez un produit et entrez la quantité',
        search: {
            placeholder: 'Rechercher par nom',
            tooltip: 'Ouvrir le scanner',
            Warehouse: "Entrepôt",
        },
        column: {
            invoice: "Facture",
            image: 'Photo',
            name: 'Nom',
            price: 'Prix',
            buying_price: "Prix d'achat",
            selling_price: 'Prix de vente',
            sku: 'SKU',
            stock: 'Stock',
            quantity: 'Quantité',
            latest_stock: 'Restant',
            product_deleted: 'Le produit a été supprimé',
            info_not_found: 'Information non disponible',
            expired_date: "Date d'expiration"
        },
        no_product: 'Aucun produit disponible',
        no_product_subtitle: 'Ajoutez votre premier produit pour commencer à suivre les stocks, les prix et les ventes.',
        create_first_product: 'Créer votre premier produit',
        add_product: {
            sku: 'Code produit',
            sku_placeholder: 'Code produit. Exemple : 12345',
            name: 'Nom du produit',
            name_placeholder: 'Entrez le nom du produit',
            initial_stock: 'Stock initial',
            initial_stock_placeholder: 'Entrez le stock initial',
            buying_price: "Prix d'achat",
            buying_price_placeholder: "Entrez le prix d'achat",
            selling_price: 'Prix de vente',
            selling_price_placeholder: 'Entrez le prix de vente',
            category: 'Catégorie',
            category_placeholder: 'Sélectionnez la catégorie',
            add_selling_price: 'Ajouter le prix de gros',
            expired_date: "Date d'expiration",
            expired_date_placeholder: 'Sélectionnez la date',
            description: 'Description',
            description_placeholder: 'Entrez la description',
            Warehouse: "Entrepôt",
        },
        choose_selling_price: 'Choisir le prix de vente',
        selling_price: 'Prix de vente',
        total_product: 'Total des produits',
        total_quantity: 'Total du stock',
        total_buying_price: "Prix d'achat total",
        total_selling_price: 'Prix de vente total',
        message: {
            required_name: 'Le nom du produit est requis',
            required_sku: 'Le SKU est requis',
            required_category: 'La catégorie est requise',
            required_quantity: 'Le stock initial est requis',
            invalid_input_qty: 'Quantité de stock invalide',
            required_buying_price: "Le prix d'achat est requis",
            required_selling_price: 'Le prix de vente est requis',
            required_selling_price_name: 'Le nom du prix de vente est requis',
            required_selling_price_price: 'Le prix de vente est requis'
        },
        viewMore: 'Voir plus',
        WarehouseDetails: "Détails de l'entrepôt",
        WarehouseName: "Nom de l'entrepôt",
        AddWarehouse: 'Ajouter un entrepôt',
        WarehouseQty: 'Quantité en entrepôt',
        Warehouse: 'Entrepôt',
        Warehouses: 'Entrepôts',
        Variants: 'Variantes',
        VariantName: 'Nom de la variante',
        productVariant: 'Variantes de produit',
        AddVariant: 'Ajouter des variantes',
        TranferItem: 'Transférer des articles',
        AddUnit: 'Nouvelle unité',
        InitialStkWarehouse: 'Stock initial requis pour ajouter des variantes',
        InitialStockinwarehouse: 'Stock initial en entrepôt',
        TotalQuantity: 'Quantité totale:',
        AddNote: 'Ajouter une note (Prix de revient)',
        AddNotetitle: 'Ajouter une note',
        VariantSuccessMessage: 'Variante de produit mise à jour avec succès',
        Next: 'Suivant',
        Submit: 'Soumettre',
        INACTIVE: 'INACTIF',
        errorone: 'Oups ! La quantité demandée pour',
        errortwo:
            "ne correspond pas aux quantités allouées à l'entrepôt. Veuillez ajuster la quantité ou réapprovisionner.",
        SelectWarehouse: "Sélectionner l'entrepôt",
        SelectVariant: 'Sélectionner la variante',
        Discount: 'Remise',
        DiscountDetails: 'Détails de la remise',
        FinalPrice: 'Prix final',
        DiscountType: 'Type de remise',
        DiscountPer: 'Remise %',
        DiscountValue: 'Valeur de la remise',
        Discountonprice: 'ಬೆಲೆಯ ಮೇಲೆ ರಿಯಾಯಿತಿ',
        Discountondiscount: 'ರಿಯಾಯಿತಿಯ ಮೇಲೆ ರಿಯಾಯಿತಿ',
        AdditionalDiscount: 'ಹೆಚ್ಚುವರಿ ರಿಯಾಯಿತಿ',
        SellingPrice: 'ಮಾರಾಟದ ಬೆಲೆ:',
        Save: 'ಉಳಿಸಿ',
        OnOriginalPrice: 'Sur le prix original',
        OnDiscountedPrice: 'Sur le prix réduit',
        columnSelector: {
            title: 'Afficher les colonnes',
            columnsButton: 'Colonnes',
            costPrice: 'Prix de revient',
            sellingPrice: 'Prix de vente',
            sku: 'SKU',
            warehouse: 'Entrepôt',
            categories: 'Catégories',
            safetyStock: 'Stock de sécurité',
            attributes: 'Attributs',
            notes: 'Notes',
            description: 'Description',
            more: 'de plus',
            attribute: 'Attribut',
            attributesTitle: 'Attributs',
            categoriesTitle: 'Catégories',
            skuAliases: 'Alias SKU'
        }
    },
    note: {
        title: 'Notes',
        add: 'Ajouter une note',
        no_note: 'Aucune note disponible'
    },
    settings: {
        category: 'Catégorie',
        language: 'Langue',
        switch_business: "Changer d'entreprise",
        currencySelect: 'Devise',
        languageChangeSuccess: "Devise mise à jour avec succès",
        languageChangeErrorMessage: "Une erreur s’est produite lors de la mise à jour de la devise",
        currencyAdded: "Devise ajoutée avec succès",
        currencyDelete: "Devise supprimée avec succès",
        Selectyourpreferredlanguage: "Sélectionnez votre langue préférée",
    },
    category: {
        category_list: {
            title: 'Catégories de Produits'
        },
        add_category: {
            button: 'Nouvelle Catégorie',
            title: 'Ajouter une Nouvelle Catégorie'
        },
        edit_category: {
            title: 'Modifier la Catégorie'
        },
        name: 'Nom de la Catégorie',
        name_placeholder: 'Entrez le Nom de la Catégorie',
        no_category: 'Aucune catégorie disponible'
    },
    staff: {
        add: 'Ajouter du Personnel',
        edit: 'Modifier le Personnel',
        access: {
            stock: 'Stock',
            add_product: 'Ajouter un nouveau produit',
            edit_product: 'Modifier le produit',
            delete_product: 'Supprimer le produit',
            view_capital_price: 'Voir le Prix de Coût',
            add_category: 'Ajouter une nouvelle catégorie',
            edit_category: 'Modifier la catégorie',
            delete_category: 'Supprimer la catégorie',
            add_supplier: 'Ajouter un nouveau fournisseur',
            edit_supplier: 'Modifier le fournisseur',
            delete_supplier: 'Supprimer le fournisseur',
            add_customer: 'Ajouter un nouveau client',
            edit_customer: 'Modifier le client',
            delete_customer: 'Supprimer le client',
            add_staff: 'Ajouter du personnel',
            edit_staff: 'Modifier le personnel',
            delete_staff: 'Supprimer le personnel',
            change_business_profile: "Changer le profil d'entreprise",
            access_by_product_category: 'Accès par catégorie de produit',
            no_category_message: "Vous n'avez ajouté aucune catégorie. Veuillez ajouter une catégorie.",
            expenses: 'Dépenses',
            view_expenses: 'Voir les dépenses',
            add_expenses: 'Ajouter des dépenses',
            edit_expenses: 'Modifier les dépenses',
            delete_expenses: 'Supprimer les dépenses',
            warehouse: 'Entrepôt',
            add_new_warehouse: 'Ajouter un nouvel entrepôt',
            edit_warehouse: 'Modifier l\'entrepôt',
            delete_warehouse: 'Supprimer l\'entrepôt',
            transfer_warehouse: 'Transférer l\'entrepôt',
            transfer_warehouse_approval: 'Approbation du transfert d\'entrepôt',
            access_by_warehouse: 'Accès par entrepôt',
            no_warehouse_message: 'Vous n\'avez ajouté aucun entrepôt. Veuillez ajouter une liste d\'entrepôts.',
            purchase_order: "Bon de commande",
            purchase_order_creation: "Création de bon de commande",
            purchase_order_edit: "Modification du bon de commande",
            purchase_order_cancel: "Annuler le bon de commande",
            purchase_order_reopen: "Rouvrir le bon de commande",
            purchase_order_receive: "Réception du bon de commande",
            sales_order: "Commande de vente",
            sales_order_creation: "Création de commande de vente",
            sales_order_edit: "Modification de la commande de vente",
            sales_order_cancel: "Annuler la commande de vente",
            sales_order_reopen: "Rouvrir la commande de vente",
            sales_order_receive: "Commande de vente expédiée",
            purchase_order_approval: "Approbation du bon de commande",
            sales_order_approval: "Approbation de la commande de vente",
            can_do_available_warehouse: "Entrepôt disponible",
            add_batch: "Approbation de création de lot"
            ,
            notification: 'Notification',
            staffNotification: 'Activer la notification',
            assignee: "Assigné",
        },
        no_staff: 'Aucun personnel disponible.'
    },
    code: {
        title: 'Nouveau Personnel Ajouté !',
        subtitle: "Partagez le code d'invitation ci-dessous pour rejoindre :",
        valid: 'Code valable uniquement pendant 48 heures',
        share: 'Partager sur WhatsApp',
        copied: 'Copié !',
        invalid: 'Code invalide !'
    },
    history: {
        no_history: "Pas d'historique.",
        detail: {
            remove: "Supprimer l'Historique",
            confirm: "Cette fonction affectera le stock, l'historique et les rapports existants."
        },
        no_history_selected: "Aucun historique sélectionné",
        select_history_hint: "Cliquez sur un historique dans la liste pour voir les détails",
        select_from_left: "Sélectionnez depuis le panneau de gauche",
    },
    supplier: {
        add: {
            title: 'Ajouter un Fournisseur'
        },
        edit: {
            title: 'Modifier le Fournisseur'
        },
        new: 'Nouveau fournisseur',
        no_supplier: 'Aucun fournisseur disponible.',
        bank: {
            title: 'Détails Bancaires'
        },
        note: 'Notes',
        form: {
            name: {
                label: 'Nom du Fournisseur',
                placeholder: 'Entrez le Nom du Fournisseur',
                placheolder_not_mandatory: 'Entrez le nom',
                error: {
                    required: 'Le nom ne peut pas être vide'
                }
            },
            contact: {
                label: 'Numéro de Contact',
                placeholder: '91934554432',
                error: {
                    required: 'Le numéro de contact ne peut pas être vide',
                    invalid: "Numéro invalide. Doit inclure l'indicatif du pays"
                }
            },
            bank_name: {
                label: 'Nom de la Banque',
                placeholder: 'Entrez le Nom de la Banque'
            },
            bank_account_name: {
                label: 'Nom du Titulaire du Compte',
                placeholder: 'Entrez le Nom du Titulaire du Compte'
            },
            bank_account_number: {
                label: 'Numéro de Compte',
                placeholder: 'Entrez le Numéro de Compte'
            },
            note: {
                label: 'Notes',
                placeholder: 'Ajouter des Notes'
            },
            openingBalance: {
                addBtn: 'Ajouter le solde d\'ouverture',
                label: 'Solde d\'ouverture',
                placeholder: 'Saisir le solde d\'ouverture',
                error: {
                    negative: 'Le solde d\'ouverture ne peut pas être négatif'
                }
            }
        },
        choose: 'Choisir un Fournisseur'
    },
    customer: {
        add: {
            title: 'Ajouter un Client'
        },
        edit: {
            title: 'Modifier le Client'
        },
        new: 'Nouveau client',
        no_customer: 'Aucun client disponible.',
        note: 'Notes',
        form: {
            name: {
                label: 'Nom du Client',
                placeholder: 'Entrez le Nom du Client',
                placheolder_not_mandatory: 'Entrez le nom ',
                error: {
                    required: 'Le nom ne peut pas être vide'
                }
            },
            contact: {
                label: 'Numéro de Contact',
                placeholder: '91934554432',
                error: {
                    required: 'Le numéro de contact ne peut pas être vide',
                    invalid: "Numéro invalide. Doit inclure l'indicatif du pays"
                }
            },
            address: {
                label: 'Adresse',
                placeholder: "Entrez l'Adresse"
            },
            note: {
                label: 'Notes',
                placeholder: 'Ajouter des Notes'
            },
            openingBalance: {
                addBtn: 'Ajouter le solde d\'ouverture',
                label: 'Solde d\'ouverture',
                placeholder: 'Saisir le solde d\'ouverture',
                error: {
                    negative: 'Le solde d\'ouverture ne peut pas être négatif'
                }
            }
        },
        choose: 'Sélectionner un Acheteur',
        report: {
            view: "Voir le Rapport de l'Acheteur",
            title: "Rapport de l'Acheteur",
            no_report: "Il n'y a pas de rapports pour les acheteurs à la date sélectionnée.",
            column: {
                name: 'Nom',
                total_transaction: 'Total des Transactions',
                total_amount: 'Total des Ventes',
                total_profit: 'Total du Profit'
            }
        }
    },
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ces données ?',
    report: {
        title: 'Rapport'
    },
    accounting: {
        download_pdf_report: 'Télécharger PDF',
        title: 'Comptabilité',
        view_report: 'Voir le Rapport Financier',
        dashboard_title: 'Rapport Financier',
        stats: 'Statistiques',
        accounting_report: 'Rapport de comptabilité',
        filter: {
            date: {
                placeholder: 'Sélectionner la Date',
                submit: 'Appliquer',
                cancel: 'Réinitialiser le Filtre'
            },
            timeframe: {
                day: 'Quotidien',
                week: 'Hebdomadaire',
                month: 'Mensuel',
                year: 'Annuel'
            }
        },
        total_sales: 'Ventes Totales',
        total_purchases: 'Achats Totals',
        total_profit: 'Profit Total',
        total_expenses: 'Dépenses Totales',
        assets_value: 'Valeur Actuelle des Actifs',
        total_current_cogs_value: 'Valeur Totale Actuelle du COGS',
        current_asset_selling_price: "Prix de Vente de l'Actif Actuel",
        total_selling_price: 'Prix de Vente Total',
        table: {
            date: 'Date',
            sales: 'Ventes',
            purchases: 'Achats',
            profit: 'Profit',
            expenses: 'Dépenses'
        },
        no_data: 'Aucune donnée disponible.'
    },
    stock_report: {
        title: 'Rapport de Stock',
        view: 'Voir le Rapport de Stock',
        no_report: 'Aucun enregistrement de stock pour la date ou le personnel sélectionné.',
        allStaffPlaceHolder: 'Tout le Personnel',
        column: {
            total_product: 'Types de Produits Actuels',
            total_product_quantity: 'Total des Produits Actuels'
        }
    },
    subscription: {
        paywall_small: {
            title: 'Fonctionnalité VIP',
            description:
                "Votre période d'essai pour cette fonctionnalité est terminée. Soutenez le développement de cette application locale en vous abonnant.",
            button: "Voir les Plans d'Abonnement"
        }
    },
    payment: {
        order: {
            title: 'Paiement'
        }
    },
    imageUploadMessage: {
        uploadSize: "La taille de l'image ne doit pas dépasser 5 Mo !",
        failedMessage: "Échec du téléchargement de l'image de l'article, veuillez réessayer !",
        successUpload: "L'image a été téléchargée avec succès !",
        failedUIError: "Échec de la suppression de l'image, veuillez réessayer !",
        SuccessErrorImage: "L'image a été supprimée avec succès !"
    },
    productColumns: {
        SKULabel: 'SKU',
        nameLabel: 'Nom du Produit',
        categoryLabel: 'Catégorie',
        BuyingPriceLabel: "Prix d'Achat",
        SellingLabel: 'Prix de Vente',
        StockLabel: 'Stock'
    },
    historyColumns: {
        Transactionlabel: 'Type de Transaction',
        Locallabel: 'Heure Locale',
        Createdlabel: 'Créé Par',
        Vendorlabel: 'Nom du Fournisseur',
        Buyerlabel: "Nom de l'Acheteur",
        SKUlabel: 'SKU',
        Productlabel: 'Nom du Produit',
        Categorylabel: 'Catégorie',
        Buyinglabel: "Prix d'Achat",
        Sellinglabel: 'Prix de Vente',
        Initiallabel: 'Stock Initial',
        Finallabel: 'Stock Final',
        Stocklabel: 'Changement de Stock'
    },
    stockReportColumns: {
        skuLabel: 'SKU',
        productNameLabel: 'Nom du Produit',
        categoryLabel: 'Catégorie',
        buyingPriceLabel: "Prix d'Achat",
        sellingPriceLabel: 'Prix de Vente',
        stockInLabel: 'Stock Entrant',
        stockOutLabel: 'Stock Sortant',
        remainingStockLabel: 'Stock Restant',
        openStockLabel: 'Stock Initial',
        weightedAverageCost: 'Coût Moyen Pondéré',
        weightedAverageCostLabel: 'Coût Moyen Pondéré',
        weightedAverageValueLabel: 'Valeur Moyenne Pondérée'
    },
    accountingReportColumns: {
        dateRange: 'Plage de dates',
        reportingPeriod: 'Période de rapport',
        reportGenerate: 'Rapport généré',
        warehouse: 'Entrepôt',
        labelDate: 'Date',
        labelSales: 'Ventes',
        labelPurchases: 'Achats',
        labelProfit: 'Profit',
        labelExpenses: 'Dépenses',
        reportOptions: 'Colonnes du rapport',
        summaryCards: 'Cartes de résumé',
        grandTotal: 'Total général',
        continued: 'suite',
        subtotal: 'Sous-total',
        page: 'Page'
    },
    customerReportColumns: {
        labelName: 'Nom',
        labelTotalTransaction: 'Transaction Totale',
        labelTotalSales: 'Ventes Totales',
        labelTotalProfit: 'Profit Total'
    },
    scannerDialog: {
        finished: 'Terminé',
        reduce: 'Réduire',
        successfull: 'Réussi',
        searching: 'Recherche...',
        title: 'Scanner actif. Dirigez-le vers le code-barres !'
    },
    historyFilter: {
        SelectBuyer: "Sélectionner l'Acheteur",
        SelectVendor: 'Sélectionner le Fournisseur'
    },
    productStockFilter: {
        StockLowtoHigh: 'Stock de Bas en Haut',
        StockHightoLow: 'Stock de Haut en Bas',
        AlphabetAZ: 'Alphabet A-Z',
        AlphabetZA: 'Alphabet Z-A'
    },
    minimizeTitle: 'Scanner actif',
    security_guarantee: {
        title: 'Sécurité des Données Garanties'
    },
    invoice: {
        invoicePlaceholder: 'Numéro de facture',
        invoiceTitle: 'Facture',
        manageInvoiceAddress: "Gérer l'adresse de facturation",
        selectOrManageAddresses: "Sélectionner, modifier ou créer des adresses de facturation personnalisées",
        useBusinessProfileAddress: "Utiliser l'adresse du profil d'entreprise",
        noCustomAddressesFound: "Aucune adresse personnalisée ajoutée",
        createCustomAddressDesc: "Ajoutez des adresses de facturation ou de succursale personnalisées à imprimer sur vos factures au lieu des données du profil d'entreprise par défaut.",
        defaultFromBusinessProfile: "Par défaut du profil d'entreprise",
        editInvoiceAddress: "Modifier l'adresse de facturation",
        createNewInvoiceAddress: "Créer une nouvelle adresse de facturation",
        logoHeaderImage: "Logo / Image d'en-tête",
        deleteInvoiceAddress: "Supprimer l'adresse de facturation ?",
        deleteAddressConfirmText: "Êtes-vous sûr de vouloir supprimer cette adresse de facturation ? Cette action est irréversible."
    },
    ManageInvoiceAddress: "Gérer l'adresse de facturation",
    SelectOrManageAddresses: "Sélectionner, modifier ou créer des adresses de facturation personnalisées",
    UseBusinessProfileAddress: "Utiliser l'adresse du profil d'entreprise",
    CreateNewAddress: "Créer une nouvelle adresse",
    UpdatingList: "Mise à jour de la liste...",
    NoCustomAddressesFound: "Aucune adresse personnalisée ajoutée",
    CreateCustomAddressDesc: "Ajoutez des adresses de facturation ou de succursale personnalisées à imprimer sur vos factures au lieu des données du profil d'entreprise par défaut.",
    DefaultFromBusinessProfile: "Par défaut du profil d'entreprise",
    EditInvoiceAddress: "Modifier l'adresse de facturation",
    CreateNewInvoiceAddress: "Créer une nouvelle adresse de facturation",
    LogoHeaderImage: "Logo / Image d'en-tête",
    UploadingImage: "Téléchargement de l'image...",
    UploadImage: "Télécharger une image",
    BusinessName: "Nom de l'entreprise",
    AddressDetails: "Détails de l'adresse",
    PhoneNumber: "Numéro de téléphone",
    EmailAddress: "Adresse e-mail",
    DeleteInvoiceAddress: "Supprimer l'adresse de facturation ?",
    DeleteAddressConfirmText: "Êtes-vous sûr de vouloir supprimer cette adresse de facturation ? Cette action est irréversible.",

    stocklowreport: {
        no_stocklowreport_one: 'Aucun article avec des paramètres de sécurité de stock.',
        no_stocklowreport_two: 'Veuillez ajouter la quantité de sécurité de stock.',
        currentStock: 'Stock actuel',
        safetyStock: 'Stock de sécurité',
        pricing: 'Tarification',
        costPrice: 'Prix de revient',
        sellingPrice: 'Prix de vente',
        productInfo: 'Informations sur le produit',
        category: 'Catégorie',
        description: 'Description',
        no_description: 'Aucune description ajoutée',
        variants: 'Variantes',
        unitsOnHand: 'unités disponibles',
        minimumThreshold: 'seuil minimum',
        adjust: 'Ajuster',
        all: 'Tous',
        lowStock: 'Stock faible',
        variantsDetails: 'Détails des variantes',
        qty: 'Qté',
        addSafetyStock: 'Ajouter un stock de sécurité',
        searchByNameSku: 'Rechercher par nom/SKU',
        safetyStockShort: 'S',
        warehouseSafetyStock: 'Stock de sécurité de l’entrepôt'
    },
    low_alert_stock: 'Entrez la quantité de sécurité de stock',
    lowStockAlertNotify: 'Vous recevrez une notification lorsque le stock sera inférieur à la quantité définie.',
    applyButtonStockAlert: 'Appliquer',
    cancelButtonStockAlert: 'Annuler',
    searchProductLabel: 'Rechercher un produit...',
    successfullyAddedSafetyStock: 'Stock de sécurité mis à jour avec succès',
    safety_Stock: 'Stock de Sécurité',
    safety_stock_placeholder: 'Entrez le Stock de Sécurité',
    lowStockDetailsInfo: {
        ProductCode: 'Code Produit',
        SafetyStock: 'Stock de Sécurité',
        Stock: 'Stock',
        CostPrice: 'Prix de Revient',
        SellingPrice: 'Prix de Vente',
        Category: 'Catégorie',
        Description: 'Description',
        ExpirationDate: "Date d'Expiration"
    },
    CustomLang: {
        Attribute: 'Attribut',
        AddAttribute: 'Ajouter un attribut',
        EditAttribute: 'Modifier un attribut',
        CustomLabePlaceholder: "Entrez le nom de l'attribut",
        CustomLabePlaceholderSelect: 'Sélectionner le type',
        AddMoreAttribute: 'Ajouter un autre attribut',
        ItemAttribute: "Attribut de l'élément",
        TableName: 'Nom',
        TableType: 'Type',
        TableAction: 'Action',
        TableDelete: 'Supprimer',
        TableEdit: 'Éditer',
        deleteMessage: 'Attribut supprimé avec succès',
        editSuccessMessage: 'Attribut mis à jour avec succès',
        AddSuccessMessage: 'Attribut ajouté avec succès',
        AddAtt: 'Ajouter',
        EditAtt: 'Éditer',
        SubmitAtt: 'Soumission...'
    },
    Expenses: {
        ExpensesTitle: 'Dépenses',
        AddExpenses: 'Ajouter des dépenses',
        ExpenseCategory: 'Catégorie de dépenses',
        NoExpenseCategory: 'Aucune catégorie de dépense',
        AddExpenseCategory: 'Ajouter une catégorie de dépenses',
        SelectExpenseCategory: 'Sélectionnez une catégorie de dépenses',
        NoExpenses: 'Aucune dépense',
        ExpensesSuccess: 'Dépenses créées avec succès',
        ExpensesSuccessEdit: 'Dépenses mises à jour avec succès',
        ExpensesCategoryName: 'Nom de la catégorie de dépenses',
        ExpensesSuccessDelete: 'Dépenses supprimées avec succès',
        TotalSpentThisWeek: 'Total dépensé cette semaine',
        AddNEC: "Ajouter une nouvelle catégorie de dépenses",
        NC: "Nouvelle catégorie de dépenses",
        EditNEC: "Modifier la catégorie de dépenses"
    },
    Manufacturing: {
        ProducedProduct: "Produit fabriqué",
        QuantityManufactured: "Quantité fabriquée",
        UnitCost: "Coût unitaire",
        RawMaterialsTotal: "Total des matières premières",
        TotalManufacturingCost: "Coût total de fabrication",
        NoRawMaterialsConsumed: "Aucune matière première consommée.",
        CostBreakdown: "Répartition des coûts",
        GeneratedBatch: "Lot généré",
        StoredBinLocation: "Emplacement de stockage",
        NoManufacturingTransactionsFound: "Aucune transaction de fabrication trouvée",
        AddManufacture: 'Ajouter les détails de fabrication',
        Manufacturing: 'Fabrication',
        RawMaterials: 'Matières premières',
        AdditonCosts: 'Coûts supplémentaires',
        RawMaterial: 'Matière première',
        AdditonCost: 'Coût supplémentaire',
        TotalCost: 'Coût total',
        AddRawMaterial: 'Ajouter des matières premières pour',
        AddAdditonCost: 'Ajouter des coûts supplémentaires pour',
        AddMore: 'Ajouter plus',
        Add: 'Ajouter',
        Update: 'Mettre à jour',
        Updating: 'Envoi en cours...',
        ProductRequired: 'Le produit est requis',
        QuantityRequired: 'La quantité est requise',
        ChargeRequired: 'Le coût est requis',
        EstimatedCostRequired: 'Le coût estimé est requis',
        PurchasePriceRequired: "Le prix d'achat est requis",
        SelectCharge: 'Sélectionner un coût',
        EstimatedCost: 'Coût estimé',
        SelectProduct: 'Sélectionner un produit',
        Quantity: 'Quantité',
        ManufactureDetails: 'Détails de fabrication',
        BuyingPrice: "Prix d'achat",
        LabourCharge: "Frais de main-d'œuvre",
        ElectricityCost: "Coût de l'électricité",
        PackagingCharge: "Frais d'emballage",
        LogisticCost: 'Coût logistique',
        OtherCharges: 'Autres frais',
        Save: 'Enregistrer les détails',
        PurchasePrice: "Prix d'achat",
        Date: 'Date',
        For: 'Pour',
        PurchaseRate: "Taux d'achat (Prix)",
        Scrolltoloadmore: 'Faites défiler pour charger plus...',
        Noproductsfound: 'Aucun produit trouvé',
        ManufacturingQuantity: 'Quantité de fabrication',
        ManufactureAddedSuccess: 'Détails de fabrication mis à jour avec succès'
    },
    Warehouses: {
        transferOrder: 'Transférer des articles',
        AddTransferOrder: 'Ajouter des articles à transférer',
        NewWarehouse: 'Nouvel entrepôt',
        newHead: 'Commencez à gérer plusieurs entrepôts !',
        headTwo: 'Suivez et gérez votre inventaire sans effort dans plusieurs entrepôts',
        EnableWarehouse: "ACTIVER L'ENTREPÔT",
        EnableWarehouse2: "Activer l'entrepôt",
        OrganizationPrimary: "Entrepôt principal de l'organisation",
        Edit: 'Modifier',
        AreEnableWarehouse: "Êtes-vous sûr de vouloir activer l'entrepôt ?",
        Confirm: 'Confirmer',
        Cancel: 'Annuler',
        WarehouseCreatedSuccessfully: 'Entrepôt créé avec succès',
        MarkAsOP: "Marquer comme entrepôt principal de l'organisation",
        MarkAsInAct: 'Marquer comme inactif',
        MarkAsAct: 'Marquer comme actif',
        MarkedAsInactive: 'Entrepôt marqué comme inactif avec succès',
        MarkedAsActive: 'Entrepôt marqué comme actif avec succès',
        MarkedAsOP: "Entrepôt marqué comme principal de l'organisation avec succès",
        WareDeletedSuccess: 'Entrepôt supprimé avec succès',
        SuccessfullyUpdatedWarehouse: 'Entrepôt mis à jour avec succès',
        SuccessfullyCreatedWarehouse: 'Entrepôt créé avec succès',
        EditWarehouse: "Modifier l'entrepôt",
        AddWarehouse: 'Ajouter un entrepôt',
        WarehouseNameIsRequired: "Le nom de l'entrepôt est requis",
        EnterWarehouseName: "Entrez le nom de l'entrepôt",
        EnterEmail: "Entrez l'email",
        EnterPhoneNumber: 'Entrez le numéro de téléphone',
        Location: 'Emplacement...',
        name: "Nom de l'entrepôt",
        email: 'Email',
        phoneNumber: 'Numéro de téléphone',
        location: 'Emplacement',
        ViewProducts: 'Voir les produits',
        PageTitle: 'Entrepôt',
        noWarehouse: "Aucun entrepôt ne correspond à votre recherche"
    },
    Assets: {
        headerTitle: 'Actifs',
        addAssetMessage:
            "Ajoutez des actifs ici. Pour attribuer un actif à un employé, accédez au profil de l'employé.",
        addAsset: 'Ajouter un Actif',
        editAsset: "Modifier l'Actif",
        assetCode: "Code de l'Actif",
        assetName: "Nom de l'Actif",
        assetCategory: "Catégorie de l'Actif",
        assetType: "Type d'Actif",
        serialNumber: 'Numéro de Série',
        location: 'Emplacement',
        condition: 'Condition',
        selectCondition: 'Sélectionner la Condition',
        fair: 'Moyen',
        good: 'Bon',
        excellent: 'Excellent',
        poor: 'Mauvais',
        notes: 'Notes',
        submit: 'Soumettre',
        submitting: 'Soumission en cours',
        noCategory: 'Aucune catégorie',
        selectCategory: 'Sélectionner une catégorie',
        addAssetCat: "Ajouter une Catégorie d'Actif",
        addAssetCatName: "Nom de la catégorie d'actif",
        edit: 'Modifier',
        status: 'Statut',
        createdAt: 'Créé le',
        viewAsset: "Voir l'Actif",
        assignAsset: "Attribuer l'Actif",
        conditionRet: 'Condition (au retour)',
        searchSelectAssets: 'Rechercher/Sélectionner un Actif',
        assetAssigned: 'Actif attribué avec succès',
        assetReturned: 'Actif retourné avec succès',
        selectAnAsset: 'Veuillez sélectionner un actif',
        action: 'Action',
        noAssetAssigned: 'Aucun actif attribué',
        reAssigned: 'Réattribuer',
        assignedAssetsList: 'Liste des Actifs Attribués',
        viewHistory: "Voir l’historique",
        history: "Historique des actifs",
        loadingHistory: "Chargement de l’historique...",
        loadingMore: "Chargement de plus...",
        dateTime: "Date et heure",
        staff: "Personnel",
        AssignedBy: "Attribué par",
        assign: "ATTRIBUER",
        return: "RETOUR",
        unknown: "INCONNU",
        noHistory: "Aucun historique disponible pour cet actif.",
        enterReturnNote: "Saisir une note pour le retour",
        returnNote: "Note de retour",
        enterAssignNote: "Saisir une note pour l’attribution",
        assignNote: "Note d’attribution",
        AddNAC: "Ajouter une nouvelle catégorie d’actifs",
        EditNAC: "Modifier la catégorie d’actifs",
        others: "Autres"
    },
    LedgerTransaction: {
        ledgerDetails: 'Détails du Registre',
        productName: 'Nom du Produit',
        totalQty: 'Quantité Totale',
        date: 'Date',
        receivedAmt: 'Montant Reçu',
        paid: 'Payé',
        discount: 'Remise',
        balance: 'Solde',
        more: 'plus',
        total: 'Total',
        ledgerupdatedsuccessfully: 'Registre mis à jour avec succès',
        ledgeraddedsuccessfully: 'Registre ajouté avec succès',
        viewLedger: 'Voir le Registre',
        edit: 'Modifier',
        create: 'Créer',
        Recieved: 'Reçu [entrée de stock]',
        payMode: 'Mode de Paiement',
        Refno: 'N° de Référence'
    },
    ExtraField: {
        attachment: "Pièce jointe",
        acceptOnlyImg: "Accepter uniquement les images.",
        addAttribute: "Ajouter un attribut",
        acceptImgAndDoc: "Accepter les images et documents."
    },
    phoneInvoiceDownload: {
        Variant: "Variante",
        Warehouse: "Entrepôt",
        Bin: "Bac",
        Batch: "Lot",
        Attributes: "Attributs"
    },
    ImportExcel: {
        ImportStockfromExcel: "Importer le stock depuis Excel",
        DragDrop: "Glissez-déposez votre fichier Excel rempli ici, ou cliquez pour parcourir",
        DT: "Télécharger le modèle",
        GB: "Retour",
        Downloading: "Téléchargement...",
        ChangeFile: "Changer le fichier",
        ReadingExcelfile: "Lecture du fichier Excel...",
        Processing: "Traitement en cours...",
        submitUpdateStock: "Valider & Mettre à jour le stock",
        downloadLatestTemplate: "Télécharger le dernier modèle",
        loginRequired: "Connexion requise"
    },
    stockForm: {
        recordPaymentNow: "Enregistrer le paiement maintenant",
        recordPaymentDescCustomer: "Saisissez le montant payé par le client",
        recordPaymentDescSupplier: "Saisissez le montant payé par le fournisseur",
        managePayments: "Gérer les paiements",
        invoice: "Facture",
        challan: "Bon de livraison",
        recordPayment: "Enregistrer le paiement",
        payableAmount: "Montant à payer",
        paidAmount: "Montant payé",
        paymentMethod: "Méthode de paiement",
        paymentDate: "Date de paiement",
        reference: "Référence",
        billId: "Numéro de facture",
        importExcel: "Importer depuis Excel",
        noThanks: "Non merci",
        checkHistory: "Voir l’historique",
        wantViewHistory: "Voulez-vous voir votre historique ?",
        enterPayable: "Entrez le montant à payer",
        enterPaid: "Entrez le montant payé",
        selectPayment: "Sélectionner le mode de paiement",
        attachment: "Pièce jointe",
        note: "Note"
    },
    HistoryEdit: {
        products: "Produits",
        add_product: "Ajouter un produit",
        paidAmountInvalidMessage: "Le montant payé ne peut pas dépasser le montant à payer",
        removingText: "Supprimer ce produit annulera les modifications de stock effectuées lors de cette transaction.",
        remove: "Supprimer"
    },
    ExcelProduct: {
        uploadFile: "Téléverser le fichier",
        dragDrop: "Glissez-déposez votre fichier Excel ou cliquez pour téléverser.",
        parsingFile: "Analyse du fichier",
        fileSelected: "Fichier sélectionné",
        reviewImportedData: "Vérifiez les données importées ci-dessous. Les colonnes sont automatiquement associées lorsque possible.",
        changeFile: "Changer de fichier",
        back: "Retour",
        invalidFileType: "Veuillez téléverser un fichier Excel valide (.xlsx ou .xls)",
        parseExcelError: "Erreur d’analyse Excel :",
        noData: "Le fichier Excel importé ne contient aucune donnée.",
        failedToRead: "Impossible de lire le fichier Excel. Veuillez réessayer.",
        Nodata: "AUCUNE_DONNÉE",
        unableToRead: "Impossible de lire le fichier.",
        buyingMustNumber: "Le prix d'achat doit être un nombre",
        sellingMustNumber: "Le prix de vente doit être un nombre",
        mustBeNumber: "doit être un nombre",
        bulkUploadfailed: "Échec du téléversement en masse",
        importFromExcel: "Importer depuis Excel",
        generating: "Génération...",
        downloadTemplate: "Télécharger le modèle",
        uploading: "Téléversement...",
        done: "Terminé",
        requiredField: "{field} est requis",
        bulkUpload: "Téléversement en masse",
        duplicateSku: "SKU en double trouvé",
        uploadedSuccessfully: "Tous les produits ont été téléchargés avec succès !",
        uploadCompleteIssues: "Téléchargement terminé avec des problèmes",
        uploaded_products: "{count} produit(s) téléchargé(s).",
        failed_products: "{count} échoué(s).",
        failed_items: "Éléments échoués :"
    },
    Discount: {
        overallDiscount: "Remise globale",
        final: "Total final",
        balanceDue: "Solde dû",
        tax: "Taxe"
    },
    ProductForm: {
        barcodeQuantity: "Saisir la quantité du code-barres",
        baseUnit: "Unité de base (principale)",
        addSecondaryUnit: "Ajouter une unité secondaire ?",
        selectUnit: "Sélectionner l’unité",
        subUnitDetails: "Détails de la sous-unité",
        subUnit: "Sous-unité",
        selectSubUnit: "Sélectionner la sous-unité",
        conversionRate: "Taux de conversion",
        exampleLogic: "Logique de l’exemple :",
        example: "Si vous vendez des stylos en boîtes, définissez l’unité de base comme Boîte et ajoutez une sous-unité (pièce) avec une conversion de 50. Cela signifie qu’une boîte contient 50 pièces.",
        basePrice: "Prix de base"
    },
    barcode: {
        settings: 'Paramètres du code-barres',
        labelSize: 'Taille de l’étiquette',
        customSize: 'Taille personnalisée...',
        widthMm: 'Largeur (mm)',
        heightMm: 'Hauteur (mm)',
        showPrice: 'Afficher le prix de vente sur l\'étiquette',
        noPrices: 'Aucun prix de vente configuré pour ce produit.',
        preview: 'Aperçu',
        generate: 'Générer',
        label: 'étiquette',
        singlePage: 'Page unique',
        downloadOptions: 'Options de téléchargement',
        chooseLayout: 'Choisissez la mise en page des codes-barres',
        allInSinglePage: 'Ajouter tous les codes-barres sur une seule page.',
        allInA4Grid: 'Tout sur une seule page',
        allInA4GridSub: 'Dispose tous les codes-barres dans une grille A4',
        onePerPage: 'Un par page',
        onePerPageSub: 'Chaque code-barres sur sa propre page d\'étiquette'
    },

    TransferItem: {
        transferItem: "Transfert d’articles",
        Date: "Date",
        Reason: "Raison",
        enterReason: "Entrer la raison",
        Name: "Nom",
        QuantityTransfered: "Quantité transférée",
        SWarehouse: "Entrepôt source",
        SelectSWarehouse: "Sélectionner l’entrepôt source",
        DWarehouse: "Entrepôt de destination",
        SelectDWarehouse: "Sélectionner l’entrepôt de destination",
        CreatedBy: "Créé par",
        CreatedTime: "Heure de création",
        UpdatedTime: "Heure de mise à jour",
        NoOrderFound: "Aucune commande trouvée",
        New: "Nouveau",
        WarehouseItemTransfer: "Transfert d’articles d’entrepôt",
        TotalTransfers: "Total des Transferts",
        EnterReason: "Entrer la raison",
        ItemDetails: "Détails de l’article",
        CurrentAvailable: "Disponibilité actuelle",
        TransferQty: "Quantité à transférer",
        SStock: "Stock source",
        DStock: "Stock destination",
        addDescription: "Ajouter une description",
        selectVariant: "Sélectionner une variante",
        addNewRow: "Ajouter une nouvelle ligne",
        typeOrSelectItem: "Tapez pour rechercher",
        scrollToLoadMore: "Faire défiler pour charger plus",
        noProductsFound: "Aucun produit trouvé",
        selectWarehouse: "Sélectionner un entrepôt"
    },
    Sku: {
        searchSelectProduct: "Rechercher / sélectionner un produit",
        searchSelectSku: "Rechercher / sélectionner SKU",
        noSkuFound: "Aucun SKU trouvé"
    },
    HistoryPage: {
        addFilter: "Ajouter un filtre",
        filtersActive: "Tous les filtres sont actifs",
        noProducts: "Aucun produit",
        download: "Télécharger",
        recentlyUpdated: "Récemment mis à jour",
    },
    StockPage: {
        challanNumber: "Numéro de bon",
        subTotal: "Sous-total",
        totalTaxes: "Totaux et taxes",
        taxInclusive: "Taxes incluses",
        discountedValue: "Valeur remisée",
        taxValue: "Valeur de la taxe",
        totalAmount: "Montant total",
        close: "Fermer",
        addTax: "Ajouter une taxe",
        label: "Libellé",
        enterLabel: "Entrer le libellé",
        taxRate: "Taux de taxe",
        enterTaxRate: "Entrer le taux de taxe",
        selectTaxRate: "Sélectionner le taux de taxe",
        addNewTax: "Ajouter un nouveau taux de taxe",
        discountProducts: "Valeur remisée (Produits)",
        taxProducts: "Valeur de la taxe (Produits)",
        clickAddPayment: "Cliquez pour ajouter un paiement",
        paidGreaterPayable: "Le montant payé ne peut pas être supérieur au montant dû",
        vendorCompulsory: "Le fournisseur est requis pour enregistrer le paiement",
        customerCompulsory: "Un client est requis pour enregistrer le paiement",
        updateInvoiceFormat: "Mettre à jour le format de facture",
        updateChallanFormat: "Mettre à jour le format du bon",
        addPrefix: "Ajouter un préfixe",
        prefix: "Préfixe"
    },
    EditHistoryPage: {
        search_by_notes: "Rechercher par notes",
        alertMessage: "Cette modification est enregistrée uniquement dans l'historique et n'affecte pas le stock actuel.",
        paymentDetails: "Détails du paiement",
        units: "Unités",
        customLabels: "Libellés personnalisés",
        value: "Valeur",
        Order_Info: "Informations de commande",
        percentage: "Pourcentage",
        Stock_updates_on_submit: "Mettre à jour le stock lors de la soumission",
        Summary: "Résumé"
    },
    historyCard: {
        paid: "PAYÉ",
        partiallyPaid: "PARTIELLEMENT PAYÉ",
        billDate: "Date de facture",
        productDetails: "Détails du produit",
        paymentsHistory: "Historique des paiements",
        updatePayment: "Mettre à jour le paiement",
        discounts: "Remises",
        inclusive: "(incl.)",
        discountOverall: "Valeur remisée (Globale)",
        dueAmount: "Montant dû",
        enterPaid: "Entrer le montant payé",
        enterReference: "Entrer la référence",
        enterNote: "Entrer une note",
        enterInvoice: "Entrer la facture",
        enterChallan: "Entrer le bon",
        edit: "Modifié"
    },
    printInvoice: {
        billTo: "Facturer à",
        ref: "Réf. n°",
        mode: "Mode",
        date: "Date",
        amount: "Montant",
        totalPaid: "Total payé"
    },
    Contact: {
        supplier_required: "Un fournisseur est requis pour l'entrée de stock",
        customer_required: "Un client est requis pour la sortie de stock",
        key: "Clé",
        editHistory: "Modifier l'historique",
        loading: "Chargement..."
    },
    AW: {
        availablewarehouse: "Entrepôt disponible",
        visibilityManagement: 'Gestion de la visibilité',
        availablewarehouses: "Entrepôts disponibles",
        Active: "Actif",
        LWarehouse: "Chargement des entrepôts...",
        NWForthisProduct: "Aucun entrepôt trouvé pour ce produit.",
        of: "de",
        WarehouseAvailabilty: "Disponibilité des entrepôts",
    },
    Currency: {
        searchCurrency: "Rechercher des devises...",
        addCurrency: "Ajouter une devise",
        addNewCurrency: "Ajouter une nouvelle devise",
        editCurrency: "Modifier la devise",
        currencySymbol: "Symbole de la devise",
        currencyName: "Nom de la devise",
        enterCurrencySymbol: "Entrez le symbole de la devise",
        enterCurrencyName: "Entrez le nom de la devise"
    },
    NewReportLang: {
        DM: "Mouvement Quotidien",
        WR: "Rapport d'Entrepôt",
        PDM: "Mouvement Quotidien du Produit",
        TBP: "Prix d'Achat Total",
        TPQ: "Quantité Totale de Produit",
        TP: "Produits Totaux",
        CS: "Stock Actuel",
        IV: "Valeur d'Inventaire",
        DA: "Moyenne Quotidienne",
        TSI: "Entrée Totale en Stock",
        TSO: "Sortie Totale de Stock",
        TOR: "Taux de Rotation",
        Tv: "Valeur Totale",
        AST: "Suivi Actif des SKU",
        UT: "Unités Suivies",
        SL: "Niveau de Stock",
        Value: "Valeur",
        IO: "ENTRÉE/SORTIE",
        T: "Rotation",
        unitsD: "Unités/Jour",
        Sort: "Trier",
        Sort_by: "Trier par",
        Units_available: "Unités disponibles",
        Units_unavailable: "Unités indisponibles",
        Current_assets: "Actifs courants",
        Search: "Rechercher",
        available: "Disponible",
        assigned: "Assigné",
        AYSWD: "Voulez-vous vraiment supprimer ?",
        PTS: "Entrepôt transféré avec succès",
        AUS: "Actifs mis à jour avec succès",
        ACS: "Actifs créés avec succès",
        VSP: "Voir le prix de vente",
        HUS: "Historique mis à jour avec succès",
    },
    ReplacementReturn: {
        selectProduct: "Veuillez sélectionner un produit",
        selectReplacementProduct: "Sélectionnez au moins un produit de remplacement",
        validQuantity: "Veuillez entrer une quantité de retour valide",
        replacedSuccessfully: "Produit remplacé avec succès",
        returnSuccessfully: "Produit retourné avec succès",
        failedProcess: "Échec du traitement. Veuillez réessayer.",
        return: "Retour",
        replace: "Remplacer",
        typeSelectProduct: "Tapez ou sélectionnez un produit...",
        returnQuantity: "Quantité à retourner",
        enterQuantity: "Entrez la quantité",
        replacementDate: "Date de remplacement",
        returnDate: "Date de retour",
        chooseCustomer: "Choisir le client",
        additionalNotes: "Ajouter des notes supplémentaires...",
        replacementProducts: "Produits de remplacement",
        addProducts: "Ajouter plus de produits",
        tapSelect: "Appuyez pour sélectionner parmi les produits disponibles",
        currently: "Actuellement",
        item: "article",
        items: "articles",
        selected: "sélectionné",
        selectedItems: "Articles sélectionnés",
        hideDetails: "Masquer plus de détails",
        showDetails: "Afficher plus de détails",
        product: "produit",
        priceLevel: "Sélectionner le niveau de prix",
        customPrice: "Entrer un prix personnalisé",
        noReplaceHistory: "Aucun historique de remplacement trouvé",
        replaceReturn: "Remplacer et Retourner",
        replaceReturnHistory: "Historique des remplacements et retours"
    },
    OtherComponent: {
        mfgHistoryTitle: "Historique de fabrication",
        mfgHistoryDesc: "Suivi des produits fabriqués",
        dailyOperation: "Opérations Quotidiennes",
        freqUsed: "Actions fréquemment utilisées pour mettre à jour les enregistrements rapidement",
        manageCategory: "Gérer les Catégories",
        organizeCaterory: "Organiser et gérer les catégories de produits, dépenses et actifs",
        businessRecord: "Dossiers d'Affaires",
        organizeRecord: "Organiser et gérer vos dossiers d'affaires",
        trackHistory: "Suivre l'Historique",
        completeTracking: "Historique complet pour l'audit et le suivi",
        Verifyinventorycount: "Vérifier le comptage des stocks",
        Exchangerates: "Taux de change",
        Productiontracking: "Suivi de production",
        Fixedassetregister: "Registre des immobilisations",
        Storagelocations: "Emplacements de stockage",
        warehouseAvailability: 'Disponibilité des produits au niveau de l\',entrepôt',
        Logreviewspend: "Journaliser et examiner les dépenses",
        Productgroupings: "Groupements de produits",
        Classifyexpenditures: "Classifier les dépenses",
        Assetclassification: "Classification des actifs",
        Manageexchanges: "Gérer les échanges",
        Returnauditlog: "Journal d'audit des retours",
        Interlocationmoves: "Mouvements entre emplacements",
        Manageoperationscategoriesrecordsandhistory: "Gérer les opérations, catégories, enregistrements et historique"
    },
    no_permission_dialog: {
        title: 'Aucune permission',
        historyDescription: "Vous n'avez pas la permission de voir l'historique des transactions. Veuillez contacter votre administrateur.",
        replacementHistoryDescription: "Vous n'avez pas la permission de voir l'historique des remplacements et retours. Veuillez contacter votre administrateur.",
        transferHistoryDescription: "Vous n'avez pas la permission de voir l'historique des transferts d'entrepôt. Veuillez contacter votre administrateur."
    },
    OthersHistory: {
        title: "Gérer l'historique",
        transferHistory: "Gérer l'historique des transferts",
        transactionHistory: "Gérer l'historique des transactions",
        replacementHistory: "Gérer l'historique des remplacements et retours"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "Parcourez et achetez les produits partagés par l'entreprise.",
        description: "Parcourez les produits partagés par l'entreprise.",
        productsAvailable: "Produits disponibles",
        noImageAvailable: "Aucune image disponible",
        productDetails: "Détails du produit",
        inStock: "en stock",
        availableVariants: "Variantes disponibles",
        options: "options",
        orders: "Commandes"
        ,
        searchProducts: "Rechercher des produits...",
        noProductsFound: "Aucun produit trouvé",
        tryDifferentKeyword: "Essayez avec un autre mot-clé",
        variants: "Variantes",
        stock: "Stock",
        cart: "Panier",
        products: "Produits",
        viewCart: "Voir le Panier",
        backToProducts: "Retour aux Produits",
        yourCart: "Votre Panier",
        clear: "Vider",
        cartEmpty: "Votre panier est vide",
        cartEmptyDesc: "Parcourez le catalogue et ajoutez les produits que vous souhaitez commander.",
        browseProducts: "Parcourir les Produits",
        selectedItems: "Articles Sélectionnés",
        itemInCart: "article dans le panier",
        itemsInCart: "articles dans le panier",
        customerDeliveryDetails: "Détails Client & Livraison",
        fullName: "Nom Complet",
        enterFullName: "Entrez votre nom complet",
        deliveryAddress: "Adresse de Livraison",
        addressPlaceholder: "Rue, bâtiment, ville, code postal...",
        orderNote: "Note de Commande (Optionnel)",
        orderNotePlaceholder: "Instructions spéciales ou notes de livraison...",
        paymentMode: "Mode de Paiement",
        subtotal: "Sous-total",
        items: "articles",
        totalAmount: "Montant Total",
        orderOnWhatsApp: "Commander via WhatsApp 📲",
        orderPlaced: "Commande Passée avec Succès ! 🎉",
        orderPlacedDesc: "Votre commande a été enregistrée et WhatsApp a été ouvert.",
        continueShopping: "Continuer les Achats 🛍️",
        cartEmptyTitle: "Panier Vide",
        cartEmptyToast: "Veuillez ajouter des produits avant de passer à la caisse.",
        incompleteTitle: "Détails Incomplets",
        incompleteToast: "Veuillez remplir tous les champs obligatoires.",
        nameRequired: "Le nom complet est requis",
        addressRequired: "L'adresse de livraison est requise",
        catalogUnavailable: "Catalogue Actuellement Indisponible",
        catalogUnavailableDesc: "Ce catalogue n'est pas actif. Contactez l'entreprise pour plus d'informations.",
        invalidCatalogLink: "Lien de Catalogue Invalide 🚫",
        invalidCatalogDesc: "Cette page de catalogue manque d'informations requises.",
        missing: "Manquant",
        catalogSlug: "Slug du Catalogue",
        goBackHome: "Retour à l'Accueil",
        inventoryManagement: "Gestion des Stocks & Facturation 🚀 Simply",
        enter: "Entrer",
        select: "Sélectionner",
        // Catalog Order translations
        catalogOrders: 'Commandes du catalogue',
        pending: 'En attente',
        converted: 'Convertie',
        cancelled: 'Annulé',
        totalRevenue: 'Valeur totale',
        totalCatalogOrders: 'Total des commandes en ligne',
        convertToSalesOrder: 'Convertir en commande client',
        date: 'Date',
        status: 'Statut',
        action: 'Action',
        searchOrders: 'Rechercher un client ou un téléphone...',
        noMatchingOrders: 'Aucune commande correspondante',
        noStatusOrders: 'Aucune commande {status} trouvée',
        tryDifferentSearch: 'Essayez de rechercher avec un autre nom de client ou numéro de téléphone.',
        noOrdersWithStatus: 'Il n\'y a actuellement aucune commande avec le statut {status}.',
        noOrdersYet: 'Aucune commande du catalogue',
        noOrdersDescription: 'Les commandes passées depuis votre catalogue en ligne apparaîtront ici.',
        guestCustomer: 'Client invité',
        item: 'Article',
        moreItems: '+{count} de plus',
        viewDetails: 'Voir les détails',
        viewSalesOrder: 'Voir la commande client',
        cancelOrder: 'Annuler la commande',
        confirmCancelTitle: 'Annuler la commande du catalogue ?',
        confirmCancelOrder: 'Êtes-vous sûr de vouloir annuler cette commande ? Cette action est irréversible.',
        keepOrder: 'Non, conserver la commande',
        confirmCancelAction: 'Oui, annuler la commande',
        orderNotFound: 'Commande du catalogue introuvable',
        orderNotFoundDescription: 'Cette commande est introuvable ou vous n\'avez pas la permission de la consulter.',
        backToCatalogOrders: 'Retour aux commandes du catalogue',
        placedOn: 'Passée le',
        totalItems: 'Total des articles',
        orderedProducts: 'Produits commandés',
        itemDetails: 'Détails de l\'article',
        quantity: 'Qté',
        unitPrice: 'Prix unitaire',
        total: 'Total',
        variant: 'Variante',
        customerInformation: 'Informations client',
        additionalFields: 'Champs supplémentaires',
        fields: 'champs',
    },
    stockNew: {
        Npay: "Aucun produit ajouté pour le moment",
        emptydesc: "Sélectionnez un produit de votre catalogue et saisissez la quantité entrante pour enregistrer le stock.",
        tipText: "Astuce : Vous pouvez également télécharger un fichier Excel",
        OT: "Total de la commande",
        Collapse: "Réduire"
    },
    deleteBulk: {
        Bulkoperation: "Opération en masse",
        Applyproducts: "Appliquer des actions à plusieurs produits",
        Bulkupload: "Téléchargement en masse",
        ImportCSVfile: "Importer des produits via un fichier Excel ou CSV",
        or: "ou",
        Bulkdelete: "Suppression en masse",
        Permanentlyallproducts: "Supprimer définitivement tous les produits",
        IrrText: "La suppression en masse est irréversible. Exportez une sauvegarde au préalable si nécessaire.",
        SeP: "Produits sélectionnés",
        sP: "Sélectionner un produit",
        DA: "Tout supprimer",
        DP: "Supprimer les produits",
        sL: "Tout sélectionner",
        ASDE: "Voulez-vous vraiment supprimer tous les produits sauf",
        ASDAllP: "Voulez-vous vraiment supprimer tous les produits ?",
        ASD: "Voulez-vous vraiment supprimer",
        products: "produits",
        TACBU: "Cette action ne peut pas être annulée.",
        LP: "Chargement des produits...",
        FM: "Chargement de plus...",
        NPF: "Aucun produit trouvé.",
        LMP: "Chargement de plus de produits..."
    },
    NewVariantModal: {
        Definevariantsassign: "Définir les variantes et attribuer les quantités",
        Nothingallocated: "Rien attribué",
        Overallocated: "Sur-alloué",
        Fullyallocated: "Entièrement attribué",
        Overby: "Excès de",
        Allvariantsneedaname: "Toutes les variantes doivent avoir un nom.",
        Reducequantities: "Réduire les quantités.",
        Overallocatedby: "Sur-alloué de",
        Quantitiesmustmatchthetotalavailability: "Les quantités doivent correspondre à la disponibilité totale.",
        Allocatequantitiesacrosswarehouses: "Attribuer les quantités entre les entrepôts",
        Notfullydistributed: "Non entièrement distribué :",
        remaining: "restant",
        Qty: "Qté",
        Inactive: "Inactif",
        left: "restant"
    },
    ProductFormNew: {
        BasicInfo: "Informations de base",
        ProductImage: "Image du produit",
        Images: "Images",
        Pricing: "Tarification",
        Everypriceneedsbothalabelandanamount: "Chaque prix doit avoir un libellé et un montant",
        AddalabellikeWholesaleorRetailtoidentifythisprice: 'Ajoutez un libellé comme "Grossiste" ou "Détail" pour identifier ce prix',
        AddMultiplePrice: "Ajouter plusieurs prix",
        NoPhotosLetAiFind: "Pas de photos ? Laissez l'IA trouver les images du produit",
        AddProductImagesTitle: "Ajouter des images de produit",
        ChooseHowToAddPhotos: "Choisissez comment vous souhaitez ajouter des photos pour ce produit :",
        SearchWithAi: "Rechercher avec l'IA",
        SearchWithAiDesc: "Trouvez et sélectionnez automatiquement des images de produits grâce à l'IA",
        FilesFileExplorer: "Fichiers (Explorateur de fichiers)",
        FilesFileExplorerDesc: "Choisissez des images directement depuis votre ordinateur",
        AiProductImageFinder: "Détecteur d'images de produit IA",
        AiProductImageFinderDesc: "Recherchez et sélectionnez des images pour votre produit",
        TypeProductNamePlaceholder: "Saisissez un nom de produit...",
        SearchForYourProduct: "Recherchez votre produit",
        SearchForYourProductHint: `Essayez un nom de marque ou de produit, ex. "Kirkland Minoxidil"`,
        ImagesSelected: "images sélectionnées",
        AddSelected: "Ajouter la sélection"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "Définir un nouveau champ personnalisé",
        AttributeName: "Nom de l'attribut",
        DataType: "Type de données",
        Noattributesfound: "Aucun attribut trouvé",
        ManageAttributes: "Gérer les attributs",
        Editordeleteexistingattributes: "Modifier ou supprimer les attributs existants",
        UpdateAttribute: "Mettre à jour l'attribut",
        Saving: "Enregistrement..."
    },
    NewExpenses: {
        Noexpensesyet: "Aucune dépense pour le moment",
        Addyourfirstexpensetostarttrackingyourspending: "Ajoutez votre première dépense pour commencer à suivre vos dépenses.",
        TOTALEXPENSES: "DÉPENSES TOTALES",
        ENTRIES: "ENTRÉES",
        BYCATEGORY: "PAR CATÉGORIE",
        Nocategoriestodisplay: "Aucune catégorie à afficher",
        DateanfTime: "Date et heure"
    },
    PurchaseSales: {
        CancelOrder: "Annuler la commande",
        ReopenOrder: "Rouvrir la commande",
        Reopen: "Rouvrir",
        ConfirmCancelOrder: "Êtes-vous sûr de vouloir annuler cette commande ?",
        ConfirmReopenOrder: "Êtes-vous sûr de vouloir rouvrir cette commande ?",
        OrderCancelledSuccessfully: "Commande annulée avec succès.",
        OrderReopenedSuccessfully: "Commande rouverte avec succès.",
        CancelledBy: "Annulé par",
        Cancelled: "Annulé",
        ConvertPriceBasedOnUnitConversion: "Convertir le prix selon la conversion d'unité",
        MarkPaymentAsPending: "Marquer le paiement comme en attente",
        PendingReceivableDesc: "Le montant sera enregistré comme créance. Enregistrez le paiement à sa réception.",
        PendingPayableDesc: "Le montant sera enregistré comme dette. Enregistrez le paiement à son règlement.",
        SelectCustomerFirst: "Sélectionnez d’abord un client",
        SelectSupplierFirst: "Sélectionnez d’abord un fournisseur",
        SelectItemsFirst: "Veuillez d'abord sélectionner au moins un article",
        PaymentMarkedPendingDesc: "Le paiement est marqué comme en attente. Décochez 'Marquer le paiement comme en attente' pour enregistrer le paiement maintenant.",
        SelectCustomerAndItemFirst: "Veuillez d'abord sélectionner un client et au moins un article",
        SelectSupplierAndItemFirst: "Veuillez d'abord sélectionner un fournisseur et au moins un article",
        SelectCustomerProductFirst: "Sélectionnez d'abord un client et un produit",
        SelectSupplierProductFirst: "Sélectionnez d'abord un fournisseur et un produit",
        Receivables: "Créances",
        Payables: "Dettes",
        AccessDenied: "Accès refusé",
        YouDonthaeP: "Vous n'avez pas la permission de voir cette page. Si vous pensez qu'il s'agit d'une erreur, contactez votre administrateur.",
        purchase: "Achat",
        sales: "Ventes",
        Areyousureyouwantto: "Êtes-vous sûr de vouloir",
        Thisactionwillupdateitsstatus: "Cette action mettra à jour son statut.",
        ReasonOPtional: "Raison (facultative)",
        Enterareasonfor: "Entrez une raison pour",
        optionalDot: "(facultatif)...",
        Reject: "Rejeter",
        ConfirmOrder: "Confirmer la commande",
        RejectOrder: "Rejeter la commande",
        Previous: "Précédent",
        First: "Premier",
        Order: "Commande",
        Items: "Articles",
        Memo: "Mémo",
        SelectDateRange: "Sélectionner la plage de dates",
        List: "Liste",
        Board: "Tableau",
        View: "Vue",
        OrderType: "Type de commande",
        SelectOrderType: "Sélectionner le type de commande",
        CreateSalesOrder: "Créer commande de vente",
        CreatePurchaseOrder: "Créer commande d'achat",
        successfully: "avec succès",
        ManageAttachments: "Gérer les pièces jointes",
        Stockoutitemsimmediatelyaftersaving: "Sortir les articles du stock immédiatement après l'enregistrement.",
        Stockinitemsimmediatelyaftersavingthisorder: "Entrer les articles en stock immédiatement après l'enregistrement de cette commande.",
        ViewAttachments: "Voir les pièces jointes",
        MemoAttachments: "Mémo & pièces jointes",
        ReceivedDate: "Date de réception",
        ShippedDate: "Date d'expédition",
        OrderDate: "Date de commande",
        OrderDetails: "Détails de la commande",
        Subtotal: "Sous-total",
        OrderSummary: "Résumé de la commande",
        AddItem: "Ajouter un article",
        NewSalesOrder: "Nouvelle commande de vente",
        NewPurchaseOrder: "Nouvelle commande d'achat",
        Createandmanageyour: "Créez et gérez vos",
        orders: "commandes",
        Removeitem: "Supprimer l'article",
        UnitPrice: "Prix unitaire",
        PurchaseOrder: "Commande d'achat",
        SalesOrder: "Commande de vente",
        PurchaseInvoice: "Facture d'achat",
        SalesInvoice: "Facture de vente",
        PurchaseOrdernotfound: "Commande d'achat non trouvée",
        Approve: "Approuver",
        MarkasShipped: "Marquer comme expédié",
        MarkasReceived: "Marquer comme reçu",
        Marking: "Marquage en cours...",
        PartiallyShip: "Expédition partielle",
        PartiallyReceive: "Réception partielle",
        Deleting: "Suppression en cours...",
        Transaction: "Transaction",
        Details: "Détails",
        Item: "Article",
        Received: "Reçu",
        Shipped: "Expédié",
        Ordered: "Commandé",
        units: "unités",
        Overalldiscount: "Remise globale",
        Transactions: "Transactions",
        Notransactionsfound: "Aucune transaction trouvée",
        OrderedQty: "Qté commandée",
        Totalqty: "Qté totale",
        StockingOut: "Sortie de stock...",
        StockingIn: "Entrée en stock...",
        thiorderUpdateStuau: "cette commande ? Cette action mettra à jour son statut.",
        TransactionDetails: "Détails de la transaction",
        Fetchingtransactiondetails: "Récupération des détails de la transaction...",
        Nodetailsfoundforthistransaction: "Aucun détail trouvé pour cette transaction.",
        TotalBreakDown: "Ventilation totale",
        ChangeAmount: "Montant de changement",
        Attachments: "Pièces jointes",
        PoNumber: "N° de commande d'achat",
        SoNumber: "N° de commande de vente",
        partner: "Partenaire",
        EditPurchase: "Modifier l'achat",
        EditSales: "Modifier la vente",
        PurchaseOrderDetails: "Détails de la commande d'achat",
        SalesOrderDetails: "Détails de la commande de vente",
        OrderTypePrepaid: "Prépayé",
        OrderTypeCOD: "Paiement à la livraison",
        OrderTypePayLater: "Payer plus tard",
        OrderTypePartialPayment: "Paiement partiel",
        OrderTypeSubscription: "Abonnement",
        viewAvailabilty: 'Voir les disponibilités',
        NotReceived: "Non reçu",
        NotShipped: "Non expédié",
        PartiallyReceived: "Partiellement reçu",
        PartiallyShipped: "Partiellement expédié",
    },
    PriceReference: {
        HighPrice: "Prix Élevé",
        LowPrice: "Prix Bas",
        LastPrice: "Dernier Prix",
        LastPurchasePrice: "Dernier prix d'achat",
        Nopricerecordsfound: "Aucun enregistrement de prix trouvé",
        BuyingPriceReference: "Référence du Prix d'Achat",
        SellingPriceReference: "Référence du Prix de Vente",
        Viewstockinpricesfortheselectedvendorandproduct: "Voir les prix d'entrée pour le fournisseur et le produit sélectionnés",
        Viewstockoutpricesfortheselectedcustomerandproduct: "Voir les prix de sortie pour le client et le produit sélectionnés"
    },
    SubscriptionLocale: {
        premiumPlan: "Plan Premium",
        heading: "Prenez des décisions commerciales",
        headingHighlight: "Basées sur les données",
        subtitle: "Débloquez toute la puissance de vos analyses d'entreprise — sans limites, sans compromis.",
        choosePlan: "Choisissez votre plan",
        monthly: "Mensuel",
        annual: "Annuel",
        oneTime: "Une fois (Mensuel)",
        perMonth: "par mois",
        perYear: "par an",
        bestValue: "Meilleur rapport qualité-prix",
        continueWith: "Continuer avec",
        perMonthShort: "mois",
        perYearShort: "an",
        troubleWithSubscription: "Problème avec l'abonnement ?",
        contactUs: "Contactez-nous",
        paymentNotReady: "Paiement non prêt",
        checkoutError: "ERREUR DE PAIEMENT",
        pricePreviewError: "ERREUR D'APERÇU DES PRIX",
        subNotAvailable: "Abonnement non disponible",
        subNotAvailableDesc: "Les abonnements web ne sont actuellement pas disponibles dans votre pays. Veuillez vous abonner via notre application mobile ou nous contacter directement pour obtenir de l'aide."
    },
    SubscriptionLocale2: {
        GoPro: "Passer à Pro",
        Makesmarterdecisionsbackedbyrealbusinessdata: "Prenez des décisions plus intelligentes soutenues par de vraies données d'affaires",
        ExploreProPlans: "Découvrir les plans Pro"
    },
    emptyWarehouseState: {
        tips: [
            "Vous pouvez avoir plusieurs entrepôts pour différents emplacements physiques",
            "Chaque produit suit le stock par entrepôt de manière indépendante",
            'Utilisez "Transférer entrepôt" pour déplacer le stock entre les emplacements'
        ],
        NoWarehousesConfigured: "Aucun entrepôt configuré",
        desc: "Commencez par ajouter vos entrepôts (si vous en avez plus d'un), puis ajoutez des produits et enregistrez les mouvements de stock.",
        WarehouseSetupTips: "Conseils de configuration d'entrepôt",
        Noproductselected: "Aucun produit sélectionné",
        Selectaproductfromthelefttoviewlowstockdetails: "Sélectionnez un produit sur la gauche pour voir les détails du stock faible.",
        Chooseaproductfromthelist: "Choisissez un produit dans la liste",
        SelectProduct: "Sélectionner un produit",
        SetQuantity: "Définir la quantité",
        Showing: "Affichage",
        products: "produits",
        Continue: "Continuer",
        SaveSafetyStock: "Enregistrer le stock de sécurité",
        SafetyStockSaved: "Stock de sécurité enregistré !",
        hasbeensetto: "a été défini à",
        AddAnother: "Ajouter un autre",
        Chooseaproduct: "Choisir un produit",
        Step: "Étape",
        of: "de",
        Setsafetyquantity: "Définir la quantité de sécurité",
        Complete: "Terminé",
        SafetyStockQuantity: "Quantité de stock de sécurité",
        Minimumunitsdropsbelowthisnumber: "Unités minimales à toujours conserver en stock. Une alerte se déclenche lorsque le stock descend en dessous de ce nombre.",
        NewSafetyStock: "Nouveau stock de sécurité",
        SafetyNow: "Sécurité maintenant",
        SettingTo: "Réglage à",
        Change: "Modifier",
        sell: "vendre",
        cost: "coût",
        BulUD: "Importation/Suppression en masse"
    },
    SimplyLoginUI: {
        sslEncryption: "Chiffrement SSL 256 bits",
        dataPrivate: "Vos données sont 100% privées",
        worksOnDevices: "Fonctionne sur Android & iPhone",
        realTimeSync: "Synchronisation en temps réel sur tous les appareils",
        cloudBackup: "Sauvegarde automatique dans le cloud",
        availableOn: "Disponible sur Web, Android & iOS",
        tagline: "Votre inventaire,",
        taglineEm: "d'une simplicité magnifique.",
        subtitle: "Connectez-vous pour gérer votre stock, suivre vos ventes et faire avancer votre entreprise — le tout au même endroit.",
        feature1Title: "Suivi du stock en temps réel",
        feature1Desc: "Sachez exactement ce qui se trouve dans chaque entrepôt, toujours à jour.",
        feature2Title: "Commandes de vente et d'achat",
        feature2Desc: "Créez des factures, gérez vos fournisseurs et suivez chaque transaction.",
        feature3Title: "Rapports intelligents",
        feature3Desc: "Rapports financiers, stock et mouvements quotidiens en un coup d'œil.",
        feature4Title: "Synchronisation en temps réel sur tous les appareils",
        feature4Desc: "Les modifications sur le téléphone apparaissent instantanément sur le web — et vice versa.",
        rating1: "Noté",
        rating2: "4.9/5",
        rating3: "par 10 000 entreprises de gros",
        brandName: "Simply",
        greeting: "Bonjour à nouveau ! 👋",
        noPasswordNeeded: "Connectez-vous pour accéder à votre inventaire — Android, iPhone & web, tout est synchronisé.",
        badge1: "Gestion des stocks",
        badge2: "Suivi des ventes",
        badge3: "Rapports",
        trustEncryptedTitle: "Chiffré",
        trustEncryptedSub: "SSL 256 bits",
        trustPrivateTitle: "Privé",
        trustPrivateSub: "Vos données uniquement",
        trustBackedTitle: "Sauvegardé",
        trustBackedSub: "Sauvegarde quotidienne auto",
        availableOnLabel: "DISPONIBLE SUR",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "Web",
        syncBadge: "Tous les appareils se synchronisent instantanément en temps réel",
        securityNote: "100% sécurisé.",
        securityDesc: "Le chiffrement de niveau bancaire protège toutes vos données. Nous ne lisons que votre nom et votre email — rien d'autre, jamais.",
        signingIn: "Connexion en cours…",
        termsPrefix: "En vous connectant, vous acceptez les",
        privacyPolicy: "Politique de Confidentialité",
        and: "et",
        termsOfService: "Conditions d'Utilisation",
        google: "Se connecter avec Google"
    },
    BatchLocal: {
        BatchName: "Nom du lot",
        EnterBatchName: "Saisir le nom du lot",
        EnterNotes: "Saisir des notes",
        ExpiredDate: "Date d'expiration",
        Selectexpireddate: "Sélectionner la date d'expiration",
        BatchStatus: "Statut du lot",
        CreatedDate: "Date de création",
        Areyousureyouwanttodeletethisbatch: "Êtes-vous sûr de vouloir supprimer ce lot ?",
        Youhavencreatedanybatchforthisproduct: "Vous n'avez créé aucun lot pour ce produit.",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "Créez votre premier lot pour commencer à suivre le stock par lot et date d'expiration.",
        Nobatchesyet: "Aucun lot pour le moment",
        Whatisbatchmanagement: "Qu'est-ce que la gestion des lots ?",
        Howithelpsyourbusiness: "Comment cela aide votre entreprise",
        Trackbylotnumber: "Suivre par numéro de lot",
        Trackbylotnumberdesc: "Regroupez le stock par lot du fabricant pour toujours savoir de quel lot provient une unité.",
        Expirydatecontrol: "Contrôle de la date d'expiration",
        Expirydatecontroldesc: "Recevez des alertes avant que le stock n'expire. Vendez d'abord les lots plus anciens et réduisez automatiquement le gaspillage.",
        Fulltraceability: "Traçabilité complète",
        Fulltraceabilitydesc: "Voyez exactement quel lot a été utilisé dans chaque transaction — idéal pour les audits et les rappels.",
        Supplierwisestock: "Stock par fournisseur",
        Supplierwisestockdesc: "Séparez le stock de différents fournisseurs même pour le même produit. Comparez la qualité lot par lot.",
        Createyourfirstbatchbutton: "Créer votre premier lot",
        Nomatchesfound: "Aucune correspondance trouvée",
        NomatchesfounddescBefore: "Nous n'avons trouvé aucun lot correspondant à ",
        NomatchesfounddescAfter: "",
        Clearsearch: "Effacer la recherche",
        Nohistoryfoundthisbatch: "Aucun historique trouvé pour ce lot",
        ComprehensiveDetails: "Détails complets",
        History: "Historique",
        InBatch: "Dans le lot",
        Noproductfoundinthisbatch: "Aucun produit trouvé dans ce lot",
        SelectBatch: "Sélectionner le lot",
        available: "disponible",
        Searchbatches: "Rechercher des lots...",
        Expires: "Expire",
        Nobatchesfound: "Aucun lot trouvé",
        ManageBatches: "Gérer les lots",
        Batchmanagement: "Gestion des lots",
        Trackstockexpiry: "Suivre le stock par lot et date d'expiration",
        Turnoffbatchmanagement: "Désactiver la gestion des lots ?",
        Yourgsafe: "Vos données de lots existantes restent en sécurité.",
        Reenableanytimefrom: "Vous pouvez le réactiver à tout moment depuis",
        Otherstab: "l'onglet Autres",
        AddBatch: "Ajouter un lot",
        Total: "Total",
        AssignProduct: "Assigner le produit",
        EditProductAssignment: "Modifier l'assignation du produit",
        AssignProducttoBatch: "Assigner le produit au lot",
        Updateproductconfiguration: "Mettre à jour la configuration du produit",
        Step1of2: "Étape 1 sur 2",
        Step2of2: "Étape 2 sur 2",
        Selectvariantwarehouse: "Sélectionner la variante et l'entrepôt",
        SelectedProduct: "Produit sélectionné",
        AssignQuantity: "Assigner la quantité",
        BatchInfo: "Informations sur le lot",
        Wecouldnthisproductidentifier: "Nous n'avons trouvé aucun lot associé à cet identifiant de produit.",
        NoActiveBatches: "Aucun lot actif",
        Endofresults: "Fin des résultats",
        Expiry: "Expiration",
        BatchManagementDescription: "Suivez le stock par numéro de lot et date d'expiration. Garantit le bon ordre LIFO / FEFO à chaque sortie de stock — aucune sélection manuelle n'est nécessaire.",
        Expiryalerts: "Alertes d'expiration",
        Autonotifications: "Notifications automatiques",
        LIFOsorting: "Tri LIFO / FEFO",
        Smartstockflow: "Flux de stock intelligent",
        Perout: "Sortie de stock par lot",
        Precisiontracking: "Suivi de précision",
        NeedsReview: "Nécessite une révision",
        Pending: "En attente",
        Rejected: "Rejeté",
        Approved: "Approuvé",
        WaitingForApproval: "En attente d'approbation",
        WaitingForApprovalDesc: "Votre propriétaire examinera et approuvera ce lot sous peu.",
        BatchRejected: "Lot rejeté",
        BatchRejectedDesc: "Votre propriétaire a rejeté ce lot.",
        Reason: "Raison",
        Approve: "Approuver",
        Reject: "Rejeter",
        ConfirmApproveTitle: "Approuver le lot",
        ConfirmRejectTitle: "Rejeter le lot",
        ConfirmApprovalAction: "Êtes-vous sûr de vouloir {action} ce lot ? Cette action mettra à jour son statut.",
        ReasonOptional: "Raison (Optionnel)",
        EnterReasonPlaceholder: "Entrez une raison pour {action} (optionnel)",
        Processing: "Traitement en cours...",
        BatchActivatedSuccess: "Lot activé avec succès",
        BatchDeactivatedSuccess: "Lot désactivé avec succès",
        BatchDeletedSuccess: "Lot supprimé avec succès",
        BatchApprovedSuccess: "Lot approuvé avec succès",
        BatchRejectedSuccess: "Lot rejeté avec succès",
        SearchByBatchName: "Rechercher par nom de lot...",
        YesTurnOff: "Oui, désactiver",
        KeepItOn: "Garder activé"
    },
    CategoryNewL: {
        TotalCategories: "Total des catégories",
        lastaddedcategory: "Dernière catégorie ajoutée",
        acrossalltypes: "dans tous les types",
        MostRecent: "Plus récent",
        YesD: "Oui, supprimer",
        AllAssociated: "Tous les produits associés peuvent être affectés"
    },
    OverDas: {
        movestockbetweenlocations: "Déplacer le stock",
        no_activity_yet: "Aucune activité pour le moment",
        no_activity_sub: "Les ventes, achats, mouvements de stock et retours apparaîtront ici en temps réel.",
        make_first_sale: "Effectuer la première vente",
        add_stock: "Ajouter du stock",
        all_stock_healthy: "Tous les niveaux de stock sont bons",
        all_stock_healthy_sub: "Aucun article n'est en rupture. Définissez des seuils minimums sur les produits pour recevoir des alertes ici.",
        set_stock_thresholds: "Définir les seuils de stock",
        no_warehouses_setup: "Aucun entrepôt configuré",
        no_warehouses_setup_sub: "Ajoutez un entrepôt pour commencer à suivre où votre stock est stocké et gérer les emplacements.",
        add_first_warehouse: "Ajouter le premier entrepôt",
        Customer: "Clients",
        PurchasevsSales: "Achats vs Ventes",
        Financialperformancechart: "Graphique de performance financière",
        QuickActions: "Actions rapides",
        Frequentlyused: "Fréquemment utilisées",
        Addinventory: "Ajouter de l'inventaire",
        Dispatchitems: "Expédier des articles",
        Addorder: "Ajouter une commande",
        Newitem: "Nouvel article",
        Inventoryaccess: "Accès à l'inventaire",
        Itemsneedingreorder: "Articles à réapprovisionner",
        Latesttransactions: "Dernières transactions",
        Operationalsummary: "Résumé opérationnel",
        ViewAll: "Voir tout",
        Manage: "Gérer",
        RecentActivity: "Activité récente",
        LowStockAlerts: "Alertes de stock faible",
        Primary: "Principal",
        TotalWarehouses: "Total des entrepôts"
    },
    SerialLocal: {
        ShowOrHideFields: "Afficher ou masquer les champs",
        ShowOrHideFieldsDesc: "Appuyez sur n'importe quel élément ci-dessous pour l'inclure ou le supprimer de la facture imprimée. Les modifications s'appliquent instantanément.",
        Manufacturesettings: "Paramètres de fabrication",
        Showbuyingprice: "prix d'achat / coût du produit",
        Showadditionalcost: "coût additionnel",
        Costbreakdown: "Répartition des coûts",
        Unitcost: "Coût unitaire",
        Rawmaterialstotal: "Total des matières premières",
        Confirmentry: "Confirmer l'entrée",
        SaveSerials: "Enregistrer les numéros de série",
        SerialNumber: "Numéro de série",
        selected: "sélectionné",
        added: "ajouté",
        Serialnumbers: "Numéros de série",
        ResetAll: "Tout réinitialiser",
        Wecouldnfindthis: "Nous n'avons trouvé aucun numéro de série disponible pour ce produit.",
        Nounitsfound: "Aucune unité trouvée",
        Searchingserialnumbers: "Recherche des numéros de série...",
        Scanorenterstock: "Scanner ou saisir les numéros de série pour le nouveau stock",
        Whataserialnumber: "Qu'est-ce qu'un numéro de série ?",
        Auniqueidentifieryourinventorylifecycle: "Un identifiant unique par unité — vous permet de suivre chaque article individuellement tout au long du cycle de vie de votre inventaire.",
        Trackedstockout: "Sortie de stock suivie",
        Chooseexactlyselected: "Choisissez exactement quels numéros de série partent. Seuls les numéros de série stockés pour ce produit sont affichés — la quantité se verrouille une fois que vous avez sélectionné ",
        SelectSerialstoout: " - Sélectionner les numéros de série à sortir",
        Thisinvoicegeneratedusingwwwsimplstockco: "Cette facture a été générée à l'aide de www.simplstock.co",
        AuthorizedSignature: "Signature autorisée",
        Invoicesettings: "Paramètres de facture",
        Draw: "Dessiner",
        Taptoselectordeselectitems: "Appuyez pour sélectionner ou désélectionner des articles",
        Thissignaturewillbeadded: "Cette signature sera ajoutée en bas de votre facture imprimée.",
        SignatureOptions: "Options de signature",
        Upload: "Télécharger",
        DrawSignature: "Dessiner la signature",
        UploadSignature: "Télécharger une signature",
        Clear: "Effacer",
        ShowStaffName: "nom du personnel",
        ShowSKU: "SKU",
        ShowBusinessName: "nom de l'entreprise",
        ShowProductName: "nom du produit",
        ShowBusinessPhoneNumber: "téléphone",
        ShowBusinessEmail: "e-mail",
        ShowBusinessAddress: "adresse",
        ShowProductImage: "image du produit",
        ShowPaymentDetails: "détails de paiement",
        ShowCategory: "catégorie",
        ShowVariant: "variante",
        ShowWarehouse: "entrepôt",
        ShowAttributes: "attributs",
        ShowQuantity: "quantité",
        ShowDiscount: "remise",
        ShowTax: "taxe",
        ShowPrice: "prix",
        ShowTotalPrice: "prix total du produit",
        ShowExpenses: "dépenses",
        ShowSignature: "signature",
        ShowNote: "note",
        showAttachment: "pièce jointe",
        ShowSerialNumber: "le numéro de série",
        Invoicesettingsapplied: "Paramètres de facture appliqués. Vérifiez la facture pour voir les modifications.",
        EnterSerialNumber: "Saisir le numéro de série",
    },
    FewLocal: {
        SelectBin: "Sélectionner le bac",
        Live: "En direct",
        Monitorinventorystocklevels: "Surveiller l'inventaire, les mouvements et les niveaux de stock",
        StockControlCentre: "Centre de contrôle des stocks",
        Nochartdataavailable: "Aucune donnée de graphique disponible",
        Disabled: "Désactivé",
        Enabled: "Activé"
    },
    Bin: {
        Bin: "Bac",
        Add: "Ajouter",
        NoBinsAddedYet: "Aucun bac ajouté pour le moment",
        BinLocationsHelp: "Les emplacements de bacs vous aident à suivre le stock par position exacte dans cet entrepôt — plus besoin de chercher.",
        NameThemByPosition: "Nommez-les par position :",
        AddBinLocation: "Ajouter un emplacement de bac",
        BinLocations: "emplacements de bac",
        BinNameRequired: "Le nom du bac est obligatoire",
        EditBin: "Modifier le bac",
        AddBin: "Ajouter un bac",
        EnterBinName: "Nom du bac",
        EnterBinNamePlaceholder: "Saisir le nom du bac",
        BinStatus: "Statut du bac",
        BinNotes: "Notes",
        EnterBinNotesPlaceholder: "Ajoutez des notes...",
        ViewInventory: "Voir l'inventaire",
        Inventory: "Inventaire",
        TrymatchingadifferentSKUname: "Essayez avec un SKU ou un nom différent.",
        Thisbinlocationcurrentlyempty: "Cet emplacement de bac est actuellement vide.",
        Loadingbins: "Chargement des bacs...",
        bins: "bacs",
        ManageBin: "Gérer le bac",
        Print: "Imprimer",
        SBin: "Bac Source",
        DBin: "Bac Destination"
    },
    WarehouseExcel: {
        title: "Télécharger Entrepôts & Emplacements de Bac",
        description: "Suivez les étapes ci-dessous pour créer en masse des entrepôts avec leurs emplacements de bac via un fichier Excel.",
        bulkUploadGuide: "Guide de Chargement en Masse",
        step1: "Étape 1",
        downloadTemplate: "Télécharger le modèle Excel",
        downloadTemplateDesc: "Obtenez le modèle officiel avec tous les en-têtes de colonnes requis. Ne renommez ni ne supprimez aucune colonne.",
        downloadTemplateBtn: "Télécharger le Modèle",
        step2: "Étape 2",
        fillExcelFile: "Remplir le fichier Excel",
        fillExcelDesc: "Chaque ligne représente un entrepôt. Remplissez toutes les colonnes — pour les emplacements de bac, saisissez tous les noms séparés par des virgules dans la colonne <code>Bin Names</code>.",
        step3: "Étape 3",
        thingsToKeepInMind: "Points importants",
        rulesDesc: "Avant de télécharger, assurez-vous que votre fichier respecte ces règles.",
        step4: "Étape 4",
        uploadYourFile: "Télécharger votre fichier",
        uploadDesc: "Une fois rempli, téléchargez le fichier ci-dessous. Le système créera automatiquement tous les entrepôts et emplacements de bac.",
        rules: ["Une ligne par entrepôt", "Noms de bac séparés par virgules dans une cellule", "Ne pas renommer les en-têtes de colonne", "Les noms de bac dupliqués par entrepôt sont ignorés", "Numéro de téléphone avec indicatif pays", "Seulement fichiers .xlsx ou .xls"],
        dropFileHere: "Déposez votre fichier Excel ici",
        supports: "Supporte .xlsx et .xls — max 10 Mo",
        chooseFileUpload: "Choisir le fichier & Télécharger",
        parsing: "Analyse du fichier...",
        invalidFileType: "Type de fichier invalide. Veuillez télécharger un fichier Excel.",
        noData: "Aucune donnée trouvée dans Excel",
        failedToRead: "Échec de la lecture du fichier Excel",
        unableToRead: "Impossible de lire le fichier.",
        reviewTitle: "Vérifier les données des entrepôts",
        reviewSubtitle: "Dernière vérification avant importation.",
        changeFile: "Changer le fichier",
        rowsFound: "lignes trouvées",
        cancel: "Annuler",
        finalizeImport: "Finaliser & Importer",
        importing: "Importation en cours...",
        success: "Succès",
        allWarehouseUploadedSuccess: "Tous les entrepôts ont été téléchargés avec succès",
        failed: "Échec",
        bulkUploadFailed: "Échec du chargement en masse",
        error: "Erreur",
        binNamesNote: "Dans la colonne <strong>Bin Names</strong>, saisissez tous les emplacements de bac dans une seule cellule séparés par des virgules — ex: A1, A2, B1, RACK-01.",
        headers: { warehouseName: "Nom de l'Entrepôt", email: "Email", phoneNumber: "Numéro de Téléphone", location: "Emplacement", binNames: "Noms de Bac" }
    },
    VariantTemplate: {
        VariantTemplates: "Modèles de Variantes",
        Managereusablevariantpatterns: "Gérer les modèles de variantes réutilisables",
        BinTransferHistory: "Historique des Transferts de Bac",
        Trackmovementsacrossbins: "Suivre les mouvements entre les bacs",
        SerialNumberHistory: "Historique des Numéros de Série",
        Trackproductserialnumberactivity: "Suivre l'activité des numéros de série des produits",
        Period: "Période",
        Nohistoryfound: "Aucun historique trouvé",
        Searchserialnumbers: "Rechercher des numéros de série...",
        SerialNumbersHistory: "Historique des Numéros de Série",
        Serialnumberhistoryglance: "Historique des numéros de série en un coup d'œil.",
        Noserialnumbersfound: "Aucun numéro de série trouvé",
        Noactivityhistoryfound: "Aucun historique d'activité trouvé",
        Statussetto: "Statut défini sur",
        Timeline: "Chronologie",
        Managereusableproductvariantpatterns: "Gérer les modèles de variantes de produits réutilisables.",
        DeleteTemplate: "Supprimer le modèle",
        Areyousureyouwanttemplate: "Êtes-vous sûr de vouloir supprimer ce modèle ?",
        CreateNewTemplate: "Créer un nouveau modèle",
        CreateTemplate: "Créer un modèle",
        EditTemplate: "Modifier le modèle",
        UnlimitedTemplates: "Modèles illimités",
        CreateAsManyTemplates: "Créez autant de modèles que vous voulez — Vêtements, Chaussures, Électronique et plus.",
        PickWhileAddingProduct: "Choisir lors de l'ajout d'un produit",
        OpenTemplateLibrary: "Ouvrez votre bibliothèque de modèles et sélectionnez des noms de variantes en quelques secondes.",
        MixFromMultipleTemplates: "Mélanger plusieurs modèles",
        SelectFromMultipleTemplates: "Sélectionnez des noms de variantes de plusieurs modèles pour un seul produit — entièrement flexible.",
        EditAnytime: "Modifier à tout moment",
        RenameTemplatesAnytime: "Renommez les modèles, ajoutez ou supprimez des noms de variantes quand votre catalogue change.",
        StayConsistent: "Restez cohérent",
        SameVariantNamesAcrossAll: "Mêmes noms de variantes sur tous les produits. Pas de fautes de frappe, pas de doublons, pas d'approximations.",
        BuildOnceUseEverywhere: "Créez une fois, utilisez partout",
        StopReEnteringVariantNames: "Arrêtez de ressaisir les mêmes noms de variantes pour chaque produit. Créez un modèle, assignez-lui des noms de variantes et réutilisez-le instantanément.",
        Updateexistingvariantcombinations: "Mettre à jour les combinaisons de variantes existantes",
        Definenewvariantcombinations: "Définir de nouvelles combinaisons de variantes",
        TemplateName: "Nom du Modèle",
        AddVariantOptions: "Ajouter des Options de Variante",
        SmallMedium: "ex. Petit, Moyen...",
        VariantsList: "Liste des Variantes",
        Nooptionsaddedyet: "Aucune option ajoutée pour le moment",
        SaveTemplate: "Enregistrer le Modèle",
        egSizesColorsetc: "ex. Tailles de T-shirt, Couleurs, etc.",
        Pleaseentertemplatename: "Veuillez entrer un nom de modèle",
        Pleaseaddatleastonevariantoption: "Veuillez ajouter au moins une option de variante",
        Templateupdatedsuccessfully: "Modèle mis à jour avec succès",
        Templatecreatedsuccessfully: "Modèle créé avec succès",
        Failedtosavetemplate: "Échec de l'enregistrement du modèle",
        Transfer: "Transférer",
        Editassignment: "Modifier l'assignation",
        Updateproductdetailsinbin: "Mettre à jour les détails du produit dans le bac",
        Editinginbin: "Modification dans le bac",
        ConfirmUpdate: "Confirmer la mise à jour",
        ConfirmAssign: "Confirmer l'assignation",
        Assignanotherproduct: "Assigner un autre produit",
        TransferBin: "Transférer le Bac",
        SourceBin: "Bac Source",
        DestinationBin: "Bac Destination",
        SelectSourceBin: "Sélectionner le Bac Source",
        SelectDestinationBin: "Sélectionner le Bac Destination",
        Unit: "Unité",
        ManageVariant: "Gérer la Variante",
        CreateSKUvariationsyourproduct: "Créer des variations SKU pour votre produit",
        Assigningvariationsto: "Assignation des variations à",
        Novariantsaddedyet: "Aucune variante ajoutée pour le moment",
        AddedVariants: "Variantes Ajoutées",
        AddVariantsfromTemplate: "Ajouter des Variantes depuis un Modèle",
        Pickatemplateandselectvariantnames: "Choisissez un modèle et sélectionnez des noms de variantes",
        ChooseaTemplate: "Choisir un Modèle",
        Selectvariantnamestoadd: "Sélectionner les noms de variantes à ajouter",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "Sélectionnez un modèle pour choisir des noms de variantes. Vous pouvez en ajouter depuis plusieurs.",
        Loadingtemplates: "Chargement des modèles...",
        Backtotemplates: "Retour aux modèles",
        Selectallindividualadd: "Sélectionnez tout ou des noms de variantes individuels à ajouter.",
        VariantNames: "Noms des Variantes",
        MediaDescription: "Médias & Description",
        Addattachmentsandproductnotes: "Ajouter des pièces jointes et des notes produit",
        ProductMedia: "Médias du Produit"
    },
    AddProductGuide: {
        title: "Ajouter la quantité initiale après enregistrement",
        description: "Les produits n'ont pas de champ quantité ici. Une fois enregistré, utilisez 'Entrée de Stock' pour enregistrer votre stock d'ouverture — avec un contrôle total sur l'emplacement et le suivi.",
        steps: {
            quantity: { title: "Quantité", sub: "Définir le stock initial" },
            binLocation: { title: "Emplacement du bac", sub: "Allée, rack, étagère — ex. A-01-03" },
            serialNumbers: { title: "Numéros de série", sub: "Suivre chaque unité individuellement" },
            warehouse: { title: "Entrepôt", sub: "Dans quel emplacement il est stocké" },
            batchExpiry: { title: "Lot / Expiration", sub: "Grouper le stock par numéro de lot" }
        },
        actions: { close: "Fermer" }
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "Aucun ordre de transfert trouvé",
        Itemshistory: "Les articles que vous transférez entre entrepôts apparaîtront ici pour le suivi et l'historique.",
        CreateTransfer: "Créer un Transfert"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "Appuyer sur le produit à fabriquer",
        Selectproductfrombelow: "Sélectionner un produit dans la liste",
        SetupANewProduct: "Configurer un nouveau produit",
        DefineAProductAdditsrawmaterial: "Définir un produit et ajouter ses matières premières",
        ManufacturingSetup: "Configuration de fabrication",
        Pickproducttodefineitsproductiondetails: "Choisir un produit pour définir ses détails de production",
        ConfigureManufacturing: "Configurer la fabrication",
        SelectRawMaterial: "Sélectionner une matière première",
        NoRawMaterials: "Aucune matière première",
        Definecomponentsneededtoproduct: "Définir les composants nécessaires à la fabrication de ce produit.",
        NoAdditionalCosts: "Aucun coût supplémentaire",
        Addlaboroverheadlogisticalcharges: "Ajouter des frais de main-d'œuvre, généraux ou logistiques.",
        AddAdditionalCost: "Ajouter un coût supplémentaire",
        AddCost: "Ajouter un coût",
        TotalPrice: "Prix total",
        SelectCharges: "Sélectionner les frais",
        EnterEstimatedCost: "Saisir le coût estimé",
        QtyRequried: "Quantité requise",
        Manufacturing: "Fabrication",
        Outputfinishedgoodsdestination: "Destination des produits finis",
        Manufacturingquantity: "Quantité de fabrication",
        Storefinishedgoodsat: "Stocker les produits finis à",
        Rawmaterials: "Matières premières",
        StockSelection: "Sélection du stock",
        AdditionalCosts: "Coûts supplémentaires",
        Quantityconsume: "Quantité à consommer",
        Totalmanufacturingcost: "Coût total de fabrication",
        Sumofrawmaterialcosts: "Somme de tous les coûts des matières premières",
        CustomManufacturingCharge: "Frais de fabrication personnalisés",
        Addextralikelaboroverheadrepairs: "Ajouter des coûts supplémentaires comme la main-d'œuvre, les frais généraux ou les réparations.",
        CalculatedTotal: "Total calculé",
        AddRawMaterial: "Ajouter une matière première",
        ConfigureRawMaterial: "Configurer la matière première",
        Thisoutputunit: "Il s'agit de la quantité de base requise par unité de sortie.",
        ChangeProduct: "Changer de produit",
        AddtoList: "Ajouter à la liste",
        ManufacturedSuccessfully: "Fabriqué avec succès",
        Manufacture: "Fabrication",
        EditDeleteHistory: "Historique Modifier/Supprimer",
        ManageOrder: "Gérer la Commande",
        ManageBatch: "Gérer le lot",
        Paymentnotavailablehere: "Paiement non disponible ici",
        Thisrecordisanorderorderitself: "Cet enregistrement provient d'une commande. Le paiement ne peut être enregistré que depuis la commande.",
        Torecorpaymenttheorderthethere: "Pour enregistrer un paiement, accédez à la commande liée et utilisez l'option <b>Enregistrer le paiement</b>.",
        GotoOrder: "Aller à la commande"
    },
    CustomerExcel: {
        title: "Télécharger les clients",
        description: "Suivez les étapes ci-dessous pour créer des clients en masse à l'aide d'un fichier Excel.",
        bulkUploadGuide: "Guide de téléchargement en masse",
        step1: "Étape 1",
        downloadTemplate: "Télécharger le modèle Excel",
        downloadTemplateDesc: "Obtenez le modèle officiel avec tous les en-têtes de colonne requis.",
        downloadTemplateBtn: "Télécharger le modèle",
        step2: "Étape 2",
        fillExcelFile: "Remplir le fichier Excel",
        fillExcelDesc: "Chaque ligne représente un client. Remplissez toutes les colonnes comme requis.",
        step3: "Étape 3",
        thingsToKeepInMind: "Choses à garder à l'esprit",
        rulesDesc: "Avant de télécharger, assurez-vous que votre fichier respecte ces règles pour éviter les erreurs.",
        step4: "Étape 4",
        uploadYourFile: "Téléchargez votre fichier",
        uploadDesc: "Une fois rempli, téléchargez le fichier ci-dessous. Le système créera automatiquement tous les clients.",
        rules: [
            "Une seule ligne par client",
            "Ne pas renommer les en-têtes de colonne",
            "Numéro de contact avec code pays",
            "Seuls les fichiers .xlsx ou .xls sont acceptés"
        ],
        dropFileHere: "Déposez votre fichier Excel ici",
        supports: "Prend en charge .xlsx et .xls — maximum 10 Mo",
        chooseFileUpload: "Choisir un fichier et télécharger",
        parsing: "Analyse du fichier...",
        invalidFileType: "Type de fichier non valide. Veuillez télécharger un fichier Excel.",
        noData: "Aucune donnée trouvée dans l'Excel",
        failedToRead: "Échec de la lecture du fichier Excel",
        unableToRead: "Impossible de lire le fichier.",
        reviewTitle: "Vérifier les données clients",
        reviewSubtitle: "Dernière vérification avant l'importation dans votre entreprise.",
        changeFile: "Changer de fichier",
        rowsFound: "lignes trouvées dans le fichier",
        cancel: "Annuler",
        finalizeImport: "Finaliser et importer",
        importing: "Importation...",
        success: "Succès",
        allCustomerUploadedSuccess: "Tous les clients ont été téléchargés avec succès",
        failed: "Échec",
        bulkUploadFailed: "Le téléchargement en masse a échoué",
        error: "Erreur",
        headers: {
            customerName: "Nom du client",
            phoneNumber: "Contact",
            address: "Adresse",
            note: "Note"
        }
    },
    SupplierExcel: {
        title: "Télécharger les fournisseurs",
        description: "Suivez les étapes ci-dessous pour créer des fournisseurs en masse à l'aide d'un fichier Excel.",
        bulkUploadGuide: "Guide de téléchargement en masse",
        step1: "Étape 1",
        downloadTemplate: "Télécharger le modèle Excel",
        downloadTemplateDesc: "Obtenez le modèle officiel avec tous les en-têtes de colonne requis.",
        downloadTemplateBtn: "Télécharger le modèle",
        step2: "Étape 2",
        fillExcelFile: "Remplir le fichier Excel",
        fillExcelDesc: "Chaque ligne représente un fournisseur. Remplissez toutes les colonnes comme requis.",
        step3: "Étape 3",
        thingsToKeepInMind: "Choses à garder à l'esprit",
        rulesDesc: "Avant de télécharger, assurez-vous que votre fichier respecte ces règles pour éviter les erreurs.",
        step4: "Étape 4",
        uploadYourFile: "Téléchargez votre fichier",
        uploadDesc: "Une fois rempli, téléchargez le fichier ci-dessous. Le système créera automatiquement tous les fournisseurs.",
        rules: [
            "Une seule ligne par fournisseur",
            "Ne pas renommer les en-têtes de colonne",
            "Numéro de contact avec code pays",
            "Seuls les fichiers .xlsx ou .xls sont acceptés"
        ],
        dropFileHere: "Déposez votre fichier Excel ici",
        supports: "Prend en charge .xlsx et .xls — maximum 10 Mo",
        chooseFileUpload: "Choisir un fichier et télécharger",
        parsing: "Analyse du fichier...",
        invalidFileType: "Type de fichier non valide. Veuillez télécharger un fichier Excel.",
        noData: "Aucune donnée trouvée dans l'Excel",
        failedToRead: "Échec de la lecture du fichier Excel",
        unableToRead: "Impossible de lire le fichier.",
        reviewTitle: "Vérifier les données fournisseurs",
        reviewSubtitle: "Dernière vérification avant l'importation dans votre entreprise.",
        changeFile: "Changer de fichier",
        rowsFound: "lignes trouvées dans le fichier",
        cancel: "Annuler",
        finalizeImport: "Finaliser et importer",
        importing: "Importation...",
        success: "Succès",
        allSupplierUploadedSuccess: "Tous les fournisseurs ont été téléchargés avec succès",
        failed: "Échec",
        bulkUploadFailed: "Le téléchargement en masse a échoué",
        error: "Erreur",
        headers: {
            supplierName: "Nom du fournisseur",
            phoneNumber: "Contact",
            bankName: "Nom de la banque",
            accountHolderName: "Nom du titulaire",
            accountNumber: "Numéro de compte",
            note: "Note"
        }
    },
    ReplaceReturnLocal: {
        ReplacedWith: "Remplacé par",
        Noreplacementhistoryfound: "Aucun historique de remplacement trouvé",
        Noreturnhistoryfound: "Aucun historique de retour trouvé",
        Productbeingreturned: "Produit retourné",
        Required: "Requis",
        Selectreturnedproduct: "Sélectionner le produit retourné",
        Searchnamescanbarcode: "Rechercher par nom, SKU ou scanner le code-barres",
        Browse: "Parcourir",
        Stockhandling: "Gestion de l'entrée en stock",
        Stockinreturnedproduct: "Entrer le produit retourné en stock",
        Ontoinventory: "Activé — l'article retourné sera réajouté à l'inventaire",
        Offreturnedonly: "Désactivé — l'article sera uniquement enregistré comme retourné",
        Usedrestock: "Utilisé pour calculer l'ajustement du profit lors du réapprovisionnement",
        Willaddedbackconfirmation: "Sera réajouté à l'inventaire après confirmation",
        Returnreason: "Motif du retour",
        Optional: "Optionnel",
        SelectReason: "Sélectionner un motif",
        Additionalnotes: "Notes complémentaires",
        Describeofcustomerexplanation: "Décrivez l'état de l'article retourné, tout dommage visible, l'explication du client...",
        Requiredmustfilledcontinue: "Les champs obligatoires doivent être remplis pour continuer",
        Reviewdetailsbeforeconfirming: "Vérifiez les détails avant de confirmer",
        Replacementproductwilldeductedinventoryconfirmation: "Le produit de remplacement sera déduit de votre inventaire après confirmation.",
        Choosereplacementproduct: "Choisir le produit de remplacement",
        Willdeductedfrominventoryconfirm: "Sera déduit de l'inventaire après confirmation",
        Thesewillattachedothereturnrecord: "Ces images seront jointes au dossier de retour",
        Replacementitem: "Article de remplacement",
        Addanotherproduct: "Ajouter un autre produit",
        Replacementproductwillbe: "Le produit de remplacement sera",
        deducted: "déduit",
        fromyourinventoryconfirmation: "de votre inventaire après confirmation.",
        productadjustedusingprice: "Le produit retourné sera réapprovisionné et le profit ajusté en utilisant le prix de vente d'origine.",
        Willloggedreturnedonlynotrestocked: "Sera uniquement enregistré comme retourné — pas de réapprovisionnement",
        Returnonly: "Retour uniquement",
        Imagesofreturnedproduct: "Images du produit retourné",
        Returnedproductwill: "Le produit retourné",
        not: "ne sera pas",
        berestockedloggedreturnedonly: "réapprovisionné — enregistré comme retourné uniquement.",
        AddImage: "Ajouter une image",
        STOCKIN: "ENTRÉE EN STOCK",
        LOGONLY: "ENREGISTREMENT UNIQUEMENT",
        ContinuetoReview: "Continuer vers la révision →",
        Confirmreplacement: "Confirmer le remplacement",
        Confirmreturn: "Confirmer le retour",
        Filldetailsbelowproceed: "Remplissez les détails ci-dessous pour continuer",
        Review: "Révision",
        editdetails: "Modifier les détails",
        Configurereturndetails: "Configurer les détails du retour",
        Configurereplacementdetails: "Configurer les détails du remplacement",
        SelectSource: "Sélectionner la source",
        Returning: "Retour en cours",
        Replacement: "Remplacement",
        WalkCustomer: "Client de passage",
        RETURNEDPRODUCT: "PRODUIT RETOURNÉ",
        REPLACEMENTPRODUCT: "PRODUIT DE REMPLACEMENT",
        STOCKOUT: "SORTIE DE STOCK",
        Netinventoryimpact: "Impact net sur l'inventaire",
        Replacementitemcost: "Coût de l'article de remplacement",
        Returneditemrestockvalue: "Valeur de restockage de l'article retourné",
        PROFITINVENTORYSUMMARY: "RÉSUMÉ DES PROFITS ET DE L'INVENTAIRE",
        Inventoryaction: "Action d'inventaire",
        Valuededucted: "Valeur déduite",
        Profitadjustment: "Ajustement du profit",
        stockedout: " sorti du stock",
        restocked: " restocké",
        Noaction: "Aucune action",
        Valuebeingreturned: "Valeur retournée",
        Willberestocked: "Sera restocké",
        Willbe: "Sera",
        logged: "enregistré",
        ON: "ON",
        OFF: "OFF",
        Linked: "Lié",
        Pleaseselectreturnedproduct: "Veuillez sélectionner un produit retourné",
        Quantityrequired: "La quantité est requise",
        Buyingpricerequired: "Le prix d'achat est requis",
        Pleaseaddleastreplacementproduct: "Veuillez ajouter au moins un produit de remplacement",
        Pleaseconfigurereturnedproductdetails: "Veuillez configurer les détails du produit retourné",
        Pleaseselectcustomer: "Veuillez sélectionner un client",
        Returndateisrequired: "La date de retour est requise",
        Pleasefillallrequiredfields: "Veuillez remplir tous les champs obligatoires",
        Wildeductedfrominventory: "Sera déduit de l'inventaire",
        Currentprice: "Prix actuel",
        Defectivedamaged: "Défectueux / endommagé",
        Wrongitemreceived: "Mauvais article reçu",
        Customerchangedmind: "Le client a changé d'avis",
        Sizefitissue: "Problème de taille / d'ajustement",
        Notasdescribed: "Non conforme à la description",
        Other: "Autre",
        Originalsaleprice: "Prix de vente original (ajusté profit)",
        Addedbackinventory: "Réajouté à l'inventaire",
        Notaddedinventory: "Non ajouté à l'inventaire",
        replacedwith: "remplacé par",
        deductedfrominventory: "déduit de l'inventaire",
        RETURNWITHSTOCKIN: "RETOUR · AVEC STOCK ENTRANT",
        RETURNNOSTOCKIN: "RETOUR · SANS STOCK ENTRANT",
        MULTIPLEREPLACEMENTS: "REMPLACEMENTS MULTIPLES",
        SINGLEREPLACEMENT: "REMPLACEMENT UNIQUE",
        InternalTrackingRecordInfo: "This is a record for internal tracking. This process DOES NOT automatically update or delete related invoices, orders, or accounts.",
        ManualStepsIfNeeded: "Manual Steps (if needed):",
        ManualStep1: "Return/Delete invoice from Sale History",
        ManualStep2: "Adjust customer ledger manually",
        ManualStep3: "Update related purchase record",
        RETURNEDSTOCKIN: "RETURNÉ · STOCK EN",
        REPLACEMENTSTOCKOUT: "REMPLACEMENT · STOCK SORTANT",
        Returnonlylogsthisentry: "Le retour enregistre uniquement cette entrée —",
        nostockwillbeaddedorremoved: "aucun stock ne sera ajouté ou retiré",
        frominventory: "de l'inventaire.",
        Whentousethis: "Quand utiliser cela :",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "Utilisez le retour en fin de journée pour enregistrer les articles envoyés pour des ventes qui sont revenus endommagés ou inutilisables — des articles que vous souhaitez suivre mais que vous ne pouvez pas réintégrer dans l'inventaire.",
        Youcanviewallpastreturnentriesin: "Vous pouvez consulter toutes les entrées de retour passées dans",
        ReturnHistory: "Historique des retours",
        underthe: "sous l'onglet",
        Others: "Autres",
        tab: ".",
        Negativestocktransactiondisabled: "Les transactions d'actions négatives sont désactivées."
    },
    NewRLocal: {
        Originalsaleprice: "Prix de vente original",
        Editinghistoryonlyinventorystaysunchanged: "Modification de l'historique uniquement — le stock reste inchangé.",
        Changeshereupdatethisdetailsquantitiesaffected: "Les modifications ici mettent à jour uniquement les détails de cet enregistrement (motif, date, notes). Vos quantités de stock réelles, emplacements de bacs et données produits ne sont pas affectés.",
        Needtofixinventorylevelsinstead: "Besoin de corriger les niveaux de stock à la place ?",
        AdjustStock: "Ajuster le stock",
        Refund: "Remboursement",
        ImportantNote: "Note importante",
        Pleasereviewbeforecontinuing: "Veuillez vérifier avant de continuer",
        Onceshippedreceivedanyupdatesmadeorder: "Une fois qu'une commande est expédiée ou reçue, toute mise à jour effectuée sur la commande ne sera pas reflétée dans l'historique des transactions.",
        Thisundone: "Cela supprimera définitivement la commande. Cette action est irréversible.",
        Inventorywilladjustedautomatically: "Le stock ne sera pas ajusté automatiquement",
        Deletingthisreversevedshippedyouwillneed: "La suppression de cette commande n'annule aucun changement de stock. Si des articles ont déjà été reçus/expédiés, vous devrez",
        reflectthecorrectstocklevels: "pour refléter les niveaux de stock corrects.",
        manuallyadjustyourinventory: "ajuster manuellement votre inventaire",
        Addremovestockforitemsthatwereshipped: "Ajouter ou retirer du stock pour les articles qui ont été expédiés",
        Addremovestockforitemsthatwerereceived: "Ajouter ou retirer du stock pour les articles qui ont été reçus",
        Updatecostrecordspaymentwaalreadymade: "Mettre à jour les enregistrements de coûts si le paiement a déjà été effectué",
        Reconcilerecordsandoutstandingpayments: "Rapprocher les dossiers et les paiements en attente"
    },
    ReceivablesLocal: {
        Receivables: "Créances",
        Manageandtrackcustomerduebalances: "Gérer et suivre les soldes dus par les clients",
        Viewcustomerduebalancereport: "Voir le rapport des soldes clients dus",
        Viewsupplierduebalancereport: "Voir le rapport des soldes fournisseurs dus",
        DueBalance: "Solde Dû",
        Unpaid: "Non Payé",
        PartiallyPaid: "Partiellement Payé",
        Paid: "Payé",
        HighestBalance: "Solde le Plus Élevé",
        LowestBalance: "Solde le Plus Bas",
        Filldetailsrecordpayment: "Remplissez les détails pour enregistrer le paiement",
        NewPaymentEntry: "Nouvelle Entrée de Paiement",
        EditPaymentEntry: "Modifier l'Entrée de Paiement",
        Nosuppliersfound: "Aucun fournisseur trouvé",
        Nocustomersfound: "Aucun client trouvé",
        LowtoHigh: "Du Plus Bas au Plus Haut",
        HightoLow: "Du Plus Haut au Plus Bas",
        AttachmentUploadedSc: "Pièce jointe téléchargée avec succès",
        AttachmentUploadedF: "Échec du téléchargement de la pièce jointe",
        Pay: "Payer",
        NoBillsFound: "Aucune facture trouvée",
        Thiscustomerhasunpaidbills: "Ce client n'a pas de factures impayées.",
        TotalDue: "Total Dû",
        BillsFound: "Factures Trouvées",
        DeselectAll: "Tout Désélectionner",
        SelectAll: "Tout Sélectionner",
        ShowDetails: "Afficher les détails"
    },
    AssetsNewLocal: {
        Assignedon: "Assigné le",
        Total: "Total",
        Assigned: "Assigné",
        Remaining: "Restant",
        Available: "Disponible",
        NoSerialNumbers: "Aucun numéro de série",
        UpdateExistingAssetDetails: "Mettre à jour les détails de l'actif existant",
        RegisterNewBusinessAsset: "Enregistrer un nouvel actif de l'entreprise",
        BasicInformation: "Informations de base",
        AssetDetails: "Détails de l'actif",
        Quantity: "Quantité",
        SerialNumbers: "Numéros de série",
        SerialNumberPlaceholder: "Numéro de série",
        AddSerialNumber: "Ajouter un numéro de série",
        SerialNumbersOptional: "Les numéros de série sont facultatifs. Vous pouvez ajouter jusqu'à",
        AssetImages: "Images de l'actif",
        AdditionalNotes: "Notes complémentaires",
        AdditionalNotesPlaceholder: "Tous détails supplémentaires ou historique de maintenance...",
        Updating: "Mise à jour...",
        Adding: "Ajout...",
        ITEquipmentPlaceholder: "ex. Équipement informatique",
        LoadingMoreActivities: "Chargement d'autres activités...",
        AssignedAssets: "Actifs Assignés",
        Noassetsassignedstaffmember: "Aucun actif assigné à ce membre du personnel.",
        Assignassetstaff: "Assigner un actif au personnel",
        Returnassetfromstaff: "Retourner cet actif du personnel",
        AssignmentDetails: "Détails de l'assignation",
        Serial: "Numéro de série",
        ViewAssets: "Voir Tous les Actifs",
        ViewByStaff: "Voir par Personnel",
        AssignedHistory: "Historique des Assignations",
        Returned: "Retourné",
        Returnedon: "Retourné le",
        ReturnedBy: "Retourné par",
        AssignedTo: "Assigné à",
        NoHistoryRecords: "Aucun enregistrement d'historique",
        Selectstaffmemberviewtheirassets: "Sélectionnez un membre du personnel pour voir ses actifs.",
        Deleted: "SUPPRIMÉ",
        searchPlaceholder: "Rechercher un actif par nom ou numéro de série..."
    },
    InventoryCountLocale: {
        InventoryCount: "Comptage d'Inventaire",
        Viewinventorycountreport: "Voir le rapport de comptage d'inventaire",
        ItemsCount: "Nombre d'articles",
        All: "Tous",
        InProgress: "En cours",
        Submitted: "Soumis",
        awaitingreview: "En attente de révision",
        EditInventoryCount: "Modifier le comptage",
        NewInventoryCount: "Nouveau comptage d'inventaire",
        Modifyinventorycountsheetdetails: "Modifier les détails de la feuille de comptage",
        Startanewinventorycountsheet: "Démarrer une nouvelle feuille de comptage",
        GeneralInformation: "Informations Générales",
        Title: "Titre",
        SaveChanges: "Enregistrer les modifications",
        Selectproductsforthisinventorycountsheet: "Sélectionner les produits pour cette feuille",
        InventoryCountDetails: "Détails du Comptage",
        Inventorycountsheetdetails: "Détails de la feuille de comptage",
        Viewingdetailsforcountsheet: "Affichage des détails de la feuille",
        Started: "Commencé",
        TaskSheets: "Feuilles de Tâche",
        Allitems: "Tous les articles",
        NotStarted: "Non commencé",
        Completed: "Terminé",
        Results: "Résultats",
        ViewResults: "Voir les Résultats",
        DeleteInventoryCount: "Supprimer le comptage",
        Viewingtransactionandadjustments: "Affichage des logs de transactions et ajustements",
        Productsadjusted: "Produits ajustés",
        Assignee: "Assigné à",
        Tasksheetdetails: "Détails de la feuille de tâche",
        Draft: "Brouillon",
        VariantQuantities: "Quantités des Variantes",
        AssignedProducts: "Produits Assignés",
        ReturnAsset: "Retourner l'Actif",
        EditTasksheet: "Modifier la Feuille de Tâche",
        NewTasksheet: "Nouvelle Feuille de Tâche",
        Updatetasksheetdetails: "Mettre à jour les détails de la feuille de tâche",
        Starttasksheetforthisinventorycount: "Démarrer une nouvelle feuille de tâche pour ce comptage",
        TaskSheetInformation: "Informations sur la Feuille de Tâche",
        SheetTitle: "Titre de la Feuille",
        Entersheettitle: "Entrer le titre de la feuille",
        SubmissionResult: "Résultat de Soumission",
        ReviewChanges: "Examiner les Modifications",
        Viewingsubmissionresultsforthisinventorycount: "Affichage des résultats de soumission pour ce comptage",
        Reviewyourinventorycountbeforesubmitting: "Vérifiez votre comptage d'inventaire avant de soumettre"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "Échec du chargement des comptages",
        NoInventoryCounts: "Aucun Comptage d'Inventaire",
        NoMatches: "Aucune Correspondance",
        Therearenoinventorycountswiththestatus: "Il n'y a aucun comptage d'inventaire avec le statut",
        Noinventorycountsfoundyoursearchterm: "Aucun comptage d'inventaire trouvé correspondant à votre terme de recherche.",
        Thereareinventorycountsrecordedyetforthisbusiness: "Aucun comptage d'inventaire n'a encore été enregistré pour cette entreprise."
    },
    StockinModalP: {
        StockInNow: "Entrer le Stock Maintenant",
        Settheopeningquantityforthisproductrightnow: "Définissez la quantité initiale pour ce produit maintenant.",
        Addinitialstock: "Ajouter le stock initial ?",
        dothislater: "Je le ferai plus tard",
        Productadded: "Produit ajouté !",
        isready: "est prêt.",
        SeeHowItWorks: "Voir Comment Ça Marche",
        NoSalesOrdersFound: "Aucune commande de vente trouvée",
        NoPurchaseOrdersFound: "Aucune commande d'achat trouvée",
        Startcreatingoutgoinginventoryrevenue: "Commencez à créer des commandes de vente pour suivre votre inventaire sortant et vos revenus.",
        Trackrestockssupplierplace: "Suivez vos réapprovisionnements et commandes fournisseurs au même endroit.",
        CreateSalesOrder: "Créer une commande de vente",
        CreatePurchaseOrder: "Créer une commande d'achat",
    }
    ,
    dialy_report: "Rapport de Mouvement Quotidien",
    Quotation: "Devis",
    Quote: "Devis",
    Assignee: "Assigné à",
    dayStart: "Début de journée",

    ShowTotalAmount: "Montant Total",


    tutorial: {
        watchTitle: 'Regardez des tutoriels étape par étape',
        watchDesc: 'Apprenez SimplyStock sur notre chaîne YouTube',
        modalTitle: 'Gardez une longueur d\'avance avec SimplyStock',
        modalDesc: 'Abonnez-vous pour obtenir de nouveaux tutoriels au moment où ils tombent',
        feature1Title: 'Nouvelles fonctionnalités pas à pas',
        feature1Sub: 'Chaque nouvelle mise à jour expliquée avec une courte vidéo — pour que vous ne manquiez jamais les nouveautés',
        feature2Title: 'Vidéos pratiques rapides',
        feature2Sub: 'Configurez le stock, les factures, l\'accès du personnel et plus encore en moins de 5 minutes',
        feature3Title: 'Notifications instantanées',
        feature3Sub: 'Recevez une notification dès qu\'un nouveau tutoriel est en ligne — apprenez à votre propre rythme',
        feature4Title: '100% gratuit, toujours',
        feature4Sub: 'Tous les tutoriels sont gratuits pour toujours — pas besoin de connexion ou d\'abonnement',
        subscribeBtn: 'S\'abonner à SimplyStock',
        maybeLater: 'Peut-être plus tard'
    }
    ,
    dailyCashReport: {
        "title": "Rapport de Caisse Quotidien",
        "subtitle": "Qui a payé quoi, à quelle date, et ce qui est encore dû — regroupé par détail des ventes.",
        "totalSales": "Ventes totales",
        "cashReceived": "Total Reçu",
        "outstanding": "Impayés",
        "collectionRate": "Taux de recouvrement",
        "grandTotalAllDates": "TOTAL GÉNÉRAL (toutes dates)",
        "totalLabel": "Total",
        "loading": "Chargement...",
        "noData": "Aucune donnée trouvée pour la plage de dates.",
        "loadingMore": "Chargement..."
    },
    dailyCashReportColumns: {
        "date": "Date",
        "customer": "Client",
        "productsSold": "Produits vendus",
        "products": "Produits",
        "salesAmount": "Montant des ventes",
        "sales": "Ventes",
        "received": "Total Reçu",
        "receivedShort": "Reçu",
        "debited": "Débité du grand livre",
        "due": "Dû",
        "paymentModes": "Mode(s) de paiement",
        "mode": "Mode"
    }
}


export default fr
